(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atelier-alfajores-capas"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('atelier-alfajor-capas')) {
  customElements.define('atelier-alfajor-capas', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.tabs = Array.from(this.querySelectorAll('[data-aac-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-aac-panel]'));
      if (!this.tabs.length || this.tabs.length !== this.panels.length) return;
      this.events = new AbortController();
      const options = {signal:this.events.signal};
      this.tabs.forEach((tab,index) => {
        tab.addEventListener('click', () => this.select(index), options);
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.tabs.length - 1;
          else return;
          event.preventDefault();
          this.select(next, true);
        }, options);
      });
      document.addEventListener('shopify:block:select', event => {
        const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail?.blockId);
        if (index >= 0) this.select(index);
      }, options);
      const initial = this.tabs.findIndex(tab => tab.getAttribute('aria-selected') === 'true');
      this.select(initial >= 0 ? initial : 0);
    }
    select(index, focus = false) {
      if (!this.tabs[index]) return;
      this.tabs.forEach((tab,i) => {
        const active = i === index;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        this.panels[i].toggleAttribute('data-active', active);
        this.panels[i].setAttribute('aria-hidden', String(!active));
        this.panels[i].inert = !active;
        this.panels[i].tabIndex = active ? 0 : -1;
      });
      if (focus) {
        const tab = this.tabs[index];
        tab.focus({preventScroll:true});
        const list = tab.parentElement;
        const listBounds = list.getBoundingClientRect();
        const tabBounds = tab.getBoundingClientRect();
        if (tabBounds.left < listBounds.left) list.scrollLeft += tabBounds.left - listBounds.left;
        else if (tabBounds.right > listBounds.right) list.scrollLeft += tabBounds.right - listBounds.right;
      }
    }
    disconnectedCallback() {
      this.events?.abort();
      this.events = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-beneficios-permanencia"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('atelier-loyalty-tabs')) {
    customElements.define('atelier-loyalty-tabs', class extends HTMLElement {
      connectedCallback() {
        this.startFrame = requestAnimationFrame(() => this.setup());
      }

      setup() {
        this.list = this.querySelector('[data-tablist]');
        this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-panel]'));
        if (!this.list || !this.tabs.length || this.tabs.length !== this.panels.length) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.list.setAttribute('role', 'tablist');
        this.list.setAttribute('aria-orientation', 'horizontal');
        this.tabs.forEach((tab, index) => {
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', this.panels[index].id);
          this.panels[index].setAttribute('role', 'tabpanel');
          this.panels[index].setAttribute('aria-labelledby', tab.id);
          tab.addEventListener('click', event => {
            event.preventDefault();
            this.activate(index, true);
          }, options);
          tab.addEventListener('keydown', event => {
            const positions = { ArrowLeft: (index - 1 + this.tabs.length) % this.tabs.length, ArrowRight: (index + 1) % this.tabs.length, Home: 0, End: this.tabs.length - 1, Enter: index, ' ': index };
            if (!(event.key in positions)) return;
            event.preventDefault();
            this.activate(positions[event.key], true);
          }, options);
        });
        this.addEventListener('shopify:block:select', event => {
          const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail.blockId);
          if (index !== -1) this.activate(index);
        }, options);
        this.setAttribute('data-enhanced', '');
        this.activate(Number(this.dataset.initialTab) || 0);
      }

      activate(index, focus = false) {
        this.index = Math.max(0, Math.min(index, this.tabs.length - 1));
        if (focus) this.tabs[this.index].focus({ preventScroll: true });
        this.tabs.forEach((tab, i) => {
          const selected = i === this.index;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          this.panels[i].setAttribute('aria-hidden', String(!selected));
          this.panels[i].inert = !selected;
          this.panels[i].tabIndex = selected ? 0 : -1;
        });
        const tab = this.tabs[this.index];
        const left = tab.offsetLeft - 5;
        const right = tab.offsetLeft + tab.offsetWidth + 5;
        if (left < this.list.scrollLeft) this.list.scrollLeft = left;
        else if (right > this.list.scrollLeft + this.list.clientWidth) this.list.scrollLeft = right - this.list.clientWidth;
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.startFrame);
        this.abort?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-buscador-catalogo"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('atelier-tag-finder')) {
  class AtelierTagFinder extends HTMLElement {
    connectedCallback() {
      if (this.connection) return;
      this.connection = new AbortController();
      const signal = this.connection.signal;
      this.groups = ['product', 'chocolate', 'diet'];
      this.selected = {product: '', chocolate: '', diet: ''};
      this.pageSize = Math.max(4, Number(this.dataset.pageSize) || 12);
      this.options = [...this.querySelectorAll('[data-option]')].map(button => ({button, id: button.dataset.option, group: button.dataset.groupKey, tag: button.dataset.tag || '', label: button.dataset.label || ''}));
      this.filters = this.options.filter(option => option.id && option.tag && option.label);
      this.byId = new Map(this.filters.map(option => [option.id, option]));
      this.grid = this.querySelector('[data-grid]');
      this.count = this.querySelector('[data-count]');
      this.status = this.querySelector('[data-load-status]');
      this.results = this.querySelector('[data-results]');
      this.error = this.querySelector('[data-load-error]');
      this.catalogLink = this.querySelector('[data-catalog-link]');
      const configNote = this.querySelector('[data-config-note]');
      if (configNote) configNote.hidden = !this.options.some(option => option.id && (!option.tag || !option.label));
      this.addEventListener('click', event => {
        const option = event.target.closest('[data-option]');
        if (option && this.contains(option) && this.ready && !option.disabled) {
          const group = option.dataset.groupKey;
          this.selected[group] = this.selected[group] === option.dataset.option ? '' : option.dataset.option;
          this.render();
        }
        const remove = event.target.closest('[data-remove-group]');
        if (remove && this.contains(remove) && this.ready) {
          this.selected[remove.dataset.removeGroup] = '';
          this.render(); this.count.focus({preventScroll: true});
        }
        if (event.target.closest('[data-clear]') && this.ready) {
          this.groups.forEach(group => {this.selected[group] = '';});
          this.render(); this.count.focus({preventScroll: true});
        }
        if (event.target.closest('[data-more]') && this.ready) {
          const previous = this.visible;
          this.visible = Math.min(this.matchesList.length, this.visible + this.pageSize);
          this.renderProducts(previous);
          if (this.querySelector('[data-more]').hidden) this.grid.children[previous]?.querySelector('.af__title a')?.focus({preventScroll: true});
        }
        if (event.target.closest('[data-retry]')) this.load(true);
      }, {signal});
      document.addEventListener('shopify:block:select', event => {
        if (this.dataset.editor !== 'true' || !this.ready) return;
        const filter = this.byId.get(event.detail?.blockId);
        if (filter) {this.selected[filter.group] = filter.id; this.render();}
      }, {signal});
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {this.observer.disconnect(); this.load(false);}
        }, {rootMargin: '250px'});
        this.observer.observe(this);
      } else this.load(false);
    }
    disconnectedCallback() {
      this.generation = (this.generation || 0) + 1;
      this.connection?.abort(); this.connection = null;
      this.loadController?.abort(); this.observer?.disconnect();
      this.ready = false;
    }
    parsePage(root) {
      const node = root.querySelector('[data-catalog-page]');
      if (!node) throw new Error('No se encontró el catálogo.');
      const data = JSON.parse(node.textContent);
      if (!Array.isArray(data.products) || !Number.isInteger(data.total) || data.total < 0 || !Number.isInteger(data.page) || data.page < 1 || !Number.isInteger(data.pages) || data.pages < 0) throw new Error('Respuesta de catálogo incompleta.');
      return data;
    }
    async fetchPage(number, pageParam, signal) {
      const url = new URL(location.href);
      url.hash = '';
      url.searchParams.delete('sections');
      url.searchParams.set('section_id', this.dataset.sectionId);
      url.searchParams.set(pageParam || 'page', String(number));
      const controller = new AbortController();
      const abort = () => controller.abort();
      signal.addEventListener('abort', abort, {once: true});
      if (signal.aborted) controller.abort();
      const timer = setTimeout(abort, 20000);
      try {
        const response = await fetch(url.href, {credentials: 'same-origin', signal: controller.signal, headers: {'Accept': 'text/html'}});
        if (!response.ok) throw new Error('No se pudo consultar Shopify.');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const root = doc.getElementById(this.id);
        if (!root) throw new Error('La sección no está disponible.');
        const data = this.parsePage(root);
        if (data.page !== number) throw new Error('Shopify no devolvió la página solicitada.');
        return data;
      } finally {
        clearTimeout(timer); signal.removeEventListener('abort', abort);
      }
    }
    async load(refresh) {
      const generation = this.generation = (this.generation || 0) + 1;
      this.loadController?.abort(); this.loadController = new AbortController();
      const signal = this.loadController.signal;
      const current = () => !signal.aborted && this.isConnected && generation === this.generation;
      this.ready = false;
      this.results.setAttribute('aria-busy', 'true');
      this.options.forEach(option => {option.button.disabled = true; option.button.querySelector('[data-filter-count]').textContent = '—';});
      this.querySelector('[data-clear]').disabled = true;
      this.grid.replaceChildren(); this.querySelector('[data-active]').replaceChildren();
      this.querySelector('[data-more-wrap]').hidden = true; this.querySelector('[data-empty]').hidden = true;
      this.error.hidden = true; this.catalogLink.hidden = true; this.status.hidden = false;
      this.count.textContent = 'Cargando catálogo…';
      this.status.textContent = 'Preparando productos y filtros.';
      if (!this.filters.length) {
        this.results.setAttribute('aria-busy', 'false'); this.count.textContent = 'Buscador de productos';
        this.status.textContent = this.dataset.editor === 'true' ? 'Completá el nombre y la etiqueta de al menos un bloque Filtro para activar el buscador.' : 'Estamos preparando las opciones de este buscador. Podés consultar nuestro catálogo completo.';
        this.catalogLink.hidden = false; return;
      }
      try {
        let first = this.parsePage(this);
        if (refresh || first.page !== 1) first = await this.fetchPage(1, first.pageParam, signal);
        if (!current()) return;
        if (first.total > 25000 || first.pages > 500) throw new Error('Esta colección supera el tamaño admitido.');
        const rows = new Map();
        const collect = data => {
          if (data.collection !== first.collection || data.total !== first.total || data.pages !== first.pages) throw new Error('El catálogo cambió durante la consulta.');
          for (const product of data.products) {
            if (product.id === undefined || !Array.isArray(product.tags) || typeof product.title !== 'string' || typeof product.url !== 'string' || typeof product.price !== 'string') throw new Error('Producto incompleto.');
            const id = String(product.id);
            if (rows.has(id)) throw new Error('La paginación repitió un producto.');
            rows.set(id, {...product, id, tagSet: new Set(product.tags)});
          }
          this.status.textContent = 'Cargando productos: ' + rows.size + ' de ' + first.total + '. Los contadores estarán disponibles al completar la carga.';
        };
        collect(first);
        for (let page = 2; page <= first.pages; page++) {
          const next = await this.fetchPage(page, first.pageParam, signal);
          if (!current()) return;
          collect(next);
        }
        if (rows.size !== first.total) throw new Error('No se recibió el catálogo completo.');
        if (!current()) return;
        const tags = new Set(this.filters.map(filter => filter.tag));
        this.products = [...rows.values()].filter(product => (this.dataset.showSoldOut !== 'false' || product.available) && product.tags.some(tag => tags.has(tag)));
        this.ready = true;
        this.results.setAttribute('aria-busy', 'false'); this.status.hidden = true;
        this.render();
      } catch (error) {
        if (!current()) return;
        this.results.setAttribute('aria-busy', 'false'); this.status.hidden = true; this.error.hidden = false;
        this.count.textContent = 'Catálogo pendiente de cargar';
        this.querySelector('[data-error-message]').textContent = 'No pudimos cargar el catálogo completo. Volvé a intentar para ver todos los productos y sus contadores.';
        if (this.dataset.editor === 'true') this.querySelector('[data-error-message]').textContent += ' Detalle: ' + error.message;
        this.catalogLink.hidden = false;
      }
    }
    matches(product, ignoredGroup) {
      return this.groups.every(group => {
        if (group === ignoredGroup || !this.selected[group]) return true;
        const filter = this.byId.get(this.selected[group]);
        return filter && product.tagSet.has(filter.tag);
      });
    }
    render() {
      if (!this.ready) return;
      for (const group of this.groups) {
        const pool = this.products.filter(product => this.matches(product, group));
        for (const option of this.options.filter(option => option.group === group)) {
          const selected = this.selected[group] === option.id;
          const valid = !option.id || Boolean(option.tag && option.label);
          const count = !valid ? 0 : option.id ? pool.filter(product => product.tagSet.has(option.tag)).length : pool.length;
          option.button.querySelector('[data-filter-count]').textContent = String(count);
          option.button.setAttribute('aria-pressed', String(selected));
          option.button.disabled = !valid || (count === 0 && !selected);
          option.button.setAttribute('aria-label', option.label + ': ' + count + (count === 1 ? ' producto' : ' productos'));
        }
      }
      const chips = document.createDocumentFragment();
      for (const group of this.groups) {
        const filter = this.byId.get(this.selected[group]);
        if (!filter) continue;
        const button = this.node('button', 'af__chip'); button.type = 'button'; button.dataset.removeGroup = group;
        button.setAttribute('aria-label', 'Quitar filtro ' + filter.label);
        button.append(this.node('span', '', filter.label));
        const cross = this.node('span', '', '×'); cross.setAttribute('aria-hidden', 'true'); button.append(cross); chips.append(button);
      }
      this.querySelector('[data-active]').replaceChildren(chips);
      this.querySelector('[data-clear]').disabled = !this.groups.some(group => this.selected[group]);
      this.matchesList = this.products.filter(product => this.matches(product));
      this.count.textContent = this.matchesList.length + (this.matchesList.length === 1 ? ' producto' : ' productos');
      this.visible = Math.min(this.pageSize, this.matchesList.length);
      this.renderProducts(0);
    }
    node(tag, className, text) {
      const node = document.createElement(tag); if (className) node.className = className;
      if (text !== undefined) node.textContent = text; return node;
    }
    safeUrl(value, image = false) {
      if (!value) return '';
      try {const url = new URL(value, location.origin); return ['http:', 'https:'].includes(url.protocol) && (image || url.origin === location.origin) ? url.href : '';} catch (_) {return '';}
    }
    productCard(product, index) {
      const card = this.node('article', 'af__card'); card.dataset.productId = product.id;
      const url = this.safeUrl(product.url);
      const media = this.node(url ? 'a' : 'div', 'af__media');
      if (url) {media.href = url; media.tabIndex = -1; media.setAttribute('aria-hidden', 'true');}
      const imageUrl = this.safeUrl(product.image, true);
      if (imageUrl) {
        const img = this.node('img', 'af__image'); img.src = imageUrl; img.alt = product.imageAlt || product.title;
        img.width = 720; img.height = 720; img.decoding = 'async';
        img.loading = index < 4 && this.getBoundingClientRect().top < innerHeight ? 'eager' : 'lazy';
        img.sizes = this.dataset.imageSizes;
        img.srcset = [[product.image360, 360], [product.image540, 540], [product.image, 720]].filter(([src]) => this.safeUrl(src, true)).map(([src, width]) => this.safeUrl(src, true) + ' ' + width + 'w').join(', ');
        media.append(img);
      } else media.append(this.node('span', 'af__placeholder', 'Imagen no disponible'));
      const category = this.filters.find(filter => filter.group === 'product' && product.tagSet.has(filter.tag));
      if (category) media.append(this.node('span', 'af__badge', category.label));
      const body = this.node('div', 'af__card-body');
      const title = this.node('h3', 'af__title'); const titleLink = this.node(url ? 'a' : 'span', '', product.title);
      if (url) titleLink.href = url; title.append(titleLink); body.append(title);
      const labels = [...new Set(this.filters.filter(filter => filter.group !== 'product' && product.tagSet.has(filter.tag)).map(filter => filter.label))];
      if (labels.length) body.append(this.node('p', 'af__tags', labels.join(' · ')));
      if (!product.available) body.append(this.node('p', 'af__sold-out', 'Agotado'));
      body.append(this.node('p', 'af__price', (product.priceVaries ? (this.dataset.fromLabel || 'Desde') + ' ' : '') + product.price));
      if (url) {
        const button = this.node('a', 'af__product-button', product.available ? (this.dataset.buttonLabel || 'Elegir opción') : 'Ver producto');
        button.href = url; button.setAttribute('aria-label', button.textContent + ': ' + product.title); body.append(button);
      }
      card.append(media, body); return card;
    }
    renderProducts(from) {
      if (!from) this.grid.replaceChildren();
      const fragment = document.createDocumentFragment();
      this.matchesList.slice(from, this.visible).forEach((product, index) => fragment.append(this.productCard(product, from + index)));
      this.grid.append(fragment);
      this.querySelector('[data-empty]').hidden = this.matchesList.length > 0;
      this.querySelector('[data-more-wrap]').hidden = this.matchesList.length === 0;
      this.querySelector('[data-shown]').textContent = 'Mostrando ' + this.visible + ' de ' + this.matchesList.length + ' productos';
      this.querySelector('[data-more]').hidden = this.visible >= this.matchesList.length;
    }
  }
  customElements.define('atelier-tag-finder', AtelierTagFinder);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-catalogo-alfajores"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('atelier-alfajor-catalog')) {
  customElements.define('atelier-alfajor-catalog', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.init());
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.alignFrame);
      this.controller?.abort();
      this.resizeObserver?.disconnect();
    }
    init() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      const grid = this.querySelector('[data-grid]');
      if (!grid) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.original = this.grid === grid && this.original ? this.original : [...grid.children];
      this.grid = grid;
      this.products = this.original.filter(el => el.hasAttribute('data-product')).map((el, index) => {
        let tags = [];
        try { tags = JSON.parse(el.dataset.tags || '[]'); } catch (_) { /* Malformed tags match no filter. */ }
        return { el, index, tags: Array.isArray(tags) ? tags : [], title: el.dataset.title || '', price: Number(el.dataset.price) || 0 };
      });
      this.filters = [...this.querySelectorAll('[data-filter]')];
      this.sort = this.querySelector('[data-sort]');
      this.selected = '';
      this.sort.value = 'featured';
      this.sort.disabled = false;
      this.filters.forEach(button => {
        const tag = button.dataset.filter;
        const count = this.products.filter(p => !tag || p.tags.includes(tag)).length;
        button.querySelector('[data-filter-count]').textContent = count;
        button.disabled = !!tag && count === 0;
      });
      this.querySelectorAll('[data-apply-tag]').forEach(button => {
        button.disabled = !this.filters.some(f => f.dataset.filter === button.dataset.applyTag && !f.disabled);
      });
      this.addEventListener('click', event => {
        const filter = event.target.closest('[data-filter]');
        if (filter && this.contains(filter) && !filter.disabled) {
          this.selected = filter.dataset.filter;
          this.render();
        }
        const action = event.target.closest('[data-apply-tag]');
        if (action && this.contains(action) && !action.disabled) {
          const target = this.filters.find(f => f.dataset.filter === action.dataset.applyTag);
          if (!target || target.disabled) return;
          this.selected = target.dataset.filter;
          this.render();
          target.focus({ preventScroll: true });
        }
      }, { signal });
      this.sort.addEventListener('change', () => this.render(), { signal });
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const filter = event.target.closest('[data-filter]');
        this.selected = filter && !filter.disabled ? filter.dataset.filter : '';
        this.sort.value = 'featured';
        this.render();
      }, { signal });
      let lastWidth = -1;
      this.resizeObserver = new ResizeObserver(entries => {
        const width = entries[0].contentRect.width;
        if (width !== lastWidth) { lastWidth = width; this.alignRows(); }
      });
      this.resizeObserver.observe(this.grid);
      this.render();
    }
    alignRows() {
      cancelAnimationFrame(this.alignFrame);
      this.alignFrame = requestAnimationFrame(() => {
        if (!this.isConnected) return;
        const cards = this.original.filter(el => !el.hidden && el.querySelector('[data-secondary-slot]'));
        const rows = new Map();
        cards.forEach(el => { el.querySelector('[data-secondary-slot]').style.minHeight = ''; });
        cards.forEach(el => {
          const row = Math.round(el.getBoundingClientRect().top);
          if (!rows.has(row)) rows.set(row, []);
          rows.get(row).push(el.querySelector('[data-secondary-slot]'));
        });
        rows.forEach(slots => {
          const height = Math.max(...slots.map(el => el.getBoundingClientRect().height));
          slots.forEach(el => { el.style.minHeight = `${height}px`; });
        });
      });
    }
    render() {
      const mode = this.sort.value;
      const matches = this.products.filter(p => !this.selected || p.tags.includes(this.selected));
      const compare = new Intl.Collator(document.documentElement.lang || 'es', { sensitivity: 'base', numeric: true });
      matches.sort((a, b) => {
        let result = 0;
        if (mode === 'price-asc') result = a.price - b.price;
        if (mode === 'price-desc') result = b.price - a.price;
        if (mode === 'title-asc') result = compare.compare(a.title, b.title);
        if (mode === 'title-desc') result = compare.compare(b.title, a.title);
        return result || a.index - b.index;
      });
      const showEditorial = !this.selected && mode === 'featured';
      const visible = new Set(matches.map(p => p.el));
      this.original.forEach(el => {
        el.hidden = el.hasAttribute('data-product') ? !visible.has(el) : !(showEditorial && (this.products.length > 0 || this.dataset.editor === 'true'));
      });
      // Restore the exact merchant block order; otherwise append sorted products only.
      const order = showEditorial ? this.original : [...matches.map(p => p.el), ...this.original.filter(el => !visible.has(el))];
      const fragment = document.createDocumentFragment();
      order.forEach(el => fragment.append(el));
      this.grid.append(fragment);
      this.filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === this.selected)));
      const label = matches.length === 1 ? this.dataset.singular : this.dataset.plural;
      this.querySelector('[data-count]').textContent = `${matches.length} ${label}`;
      const editorPreview = this.dataset.editor === 'true' && showEditorial && this.original.some(el => el.hasAttribute('data-placeholder'));
      this.querySelector('[data-empty]').hidden = matches.length > 0 || editorPreview;
      this.alignRows();
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-catalogo-filtrable"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('atelier-catalogue')) {
    customElements.define('atelier-catalogue', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.events?.abort();
        this.resizeObserver?.disconnect();
        this.readyObserver?.disconnect();
        this.initialized = false;
      }

      initialize() {
        if (this.initialized || !this.isConnected) return;
        this.grid = this.querySelector('[data-ac-grid]');
        this.empty = this.querySelector('[data-ac-empty]');
        if (!this.grid || !this.empty) {
          this.readyObserver?.disconnect();
          this.readyObserver = new MutationObserver(() => this.initialize());
          this.readyObserver.observe(this, { childList: true, subtree: true });
          return;
        }
        this.readyObserver?.disconnect();
        this.initialized = true;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.cards = Array.from(this.querySelectorAll('[data-ac-product]'));
        this.promo = this.querySelector('[data-ac-promo]');
        this.filters = this.querySelector('[data-ac-filters]');
        this.more = this.querySelector('[data-ac-more]');
        this.sort = this.querySelector('[data-ac-sort]');
        this.count = this.querySelector('[data-ac-count]');
        this.selected = '';
        this.sortValue = 'featured';
        if (this.sort) this.sort.value = 'featured';
        this.categories = new Map();
        this.cards.forEach(card => {
          const label = card.dataset.category.trim().replace(/\s+/g, ' ');
          const key = label.toLocaleLowerCase();
          card.acCategory = key;
          if (!key) return;
          const item = this.categories.get(key) || { label, count: 0 };
          item.count += 1;
          this.categories.set(key, item);
        });
        this.filters.replaceChildren();
        const addFilter = (key, label, count) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'ac-catalogue__filter';
          button.dataset.acCategory = key;
          button.setAttribute('aria-pressed', String(key === ''));
          button.setAttribute('aria-controls', this.grid.id);
          const name = document.createElement('span');
          name.textContent = label;
          const number = document.createElement('span');
          number.className = 'ac-catalogue__filter-count';
          number.textContent = count;
          button.append(name, number);
          this.filters.append(button);
        };
        addFilter('', this.dataset.allLabel, this.cards.length);
        this.categories.forEach((item, key) => addFilter(key, item.label, item.count));
        this.filters.addEventListener('click', event => {
          const button = event.target.closest('[data-ac-category]');
          if (!button || !this.filters.contains(button)) return;
          this.selected = button.dataset.acCategory;
          this.update();
        }, options);
        this.sort?.addEventListener('change', () => {
          this.sortValue = this.sort.value;
          this.update();
        }, options);
        this.more.addEventListener('click', () => {
          const end = this.filters.scrollWidth - this.filters.clientWidth;
          const atEnd = this.filters.scrollLeft >= end - 2;
          this.filters.scrollTo({ left: atEnd ? 0 : Math.min(end, this.filters.scrollLeft + this.filters.clientWidth * .7), behavior: 'auto' });
        }, options);
        const updateOverflow = () => {
          // Measure the entire wrapper so hiding/showing the arrow cannot oscillate.
          this.more.hidden = this.filters.scrollWidth <= this.filters.parentElement.clientWidth + 2;
        };
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(updateOverflow);
          this.resizeObserver.observe(this.filters.parentElement);
        }
        window.addEventListener('resize', updateOverflow, options);
        this.addEventListener('shopify:block:select', event => {
          const target = event.target.closest('[data-ac-product], [data-ac-promo]');
          if (!target || !this.contains(target)) return;
          this.selected = '';
          this.sortValue = 'featured';
          if (this.sort) this.sort.value = 'featured';
          this.update();
        }, options);
        this.querySelector('[data-ac-controls]').hidden = this.cards.length === 0;
        this.update();
        updateOverflow();
      }

      update() {
        const ordered = this.cards.slice().sort((a, b) => {
          if (this.sortValue === 'price-asc') return Number(a.dataset.price) - Number(b.dataset.price) || Number(a.dataset.order) - Number(b.dataset.order);
          if (this.sortValue === 'price-desc') return Number(b.dataset.price) - Number(a.dataset.price) || Number(a.dataset.order) - Number(b.dataset.order);
          if (this.sortValue === 'title') return a.dataset.name.localeCompare(b.dataset.name, this.dataset.locale || 'es', { sensitivity: 'base', numeric: true });
          return Number(a.dataset.order) - Number(b.dataset.order);
        });
        const visible = [];
        ordered.forEach(card => {
          card.hidden = !!this.selected && card.acCategory !== this.selected;
          if (!card.hidden) visible.push(card);
          this.grid.append(card);
        });
        this.filters.querySelectorAll('[data-ac-category]').forEach(button => {
          button.setAttribute('aria-pressed', String(button.dataset.acCategory === this.selected));
        });
        if (this.promo) {
          this.promo.hidden = (visible.length === 0 && this.cards.length > 0) || (!!this.selected && this.promo.dataset.filtered !== 'true');
          const position = Math.max(0, Number(this.promo.dataset.position) || 0);
          const next = visible[position];
          if (next) this.grid.insertBefore(this.promo, next);
          else this.grid.append(this.promo);
        }
        this.count.textContent = `${visible.length} ${visible.length === 1 ? this.dataset.singular : this.dataset.plural}`;
        this.empty.hidden = visible.length > 0;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-catalogo-productos-compacto"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('atelier-product-browser')) {
    customElements.define('atelier-product-browser', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        if (!this.querySelector('[data-empty]')) {
          this.initFrame = requestAnimationFrame(() => { if (this.isConnected) this.connectedCallback(); });
          return;
        }
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.cards = Array.from(this.querySelectorAll('[data-product-card]'));
        this.grid = this.querySelector('[data-grid]');
        this.promo = this.querySelector('[data-promo]');
        this.editorCards = Array.from(this.querySelectorAll('[data-editor-card]'));
        this.filters = Array.from(this.querySelectorAll('[data-filter]'));
        this.sort = this.querySelector('[data-sort]');
        this.activeFilter = 'all';
        this.cards.forEach(card => { card.categories = card.dataset.groups.trim().split(/\s+/).filter(Boolean); });
        this.filters.forEach(button => {
          const count = this.cards.filter(card => button.dataset.filter === 'all' || card.categories.includes(button.dataset.filter)).length;
          button.querySelector('[data-filter-count]').textContent = String(count);
          button.addEventListener('click', () => { this.activeFilter = button.dataset.filter; this.update(); }, { signal });
        });
        this.sort.addEventListener('change', () => this.update(), { signal });
        this.addEventListener('shopify:block:select', event => {
          const target = event.target.closest('[data-product-card], [data-promo]');
          if (target?.hidden) { this.activeFilter = 'all'; this.update(); }
        }, { signal });
        this.querySelector('[data-controls]').hidden = false;
        this.update();
        this.observer = new ResizeObserver(entries => {
          const width = entries[0].contentRect.width;
          if (width !== this.lastWidth) { this.lastWidth = width; this.queueAlign(); }
        });
        this.observer.observe(this);
        if (document.fonts) document.fonts.ready.then(() => { if (!signal.aborted) this.queueAlign(); });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        cancelAnimationFrame(this.initFrame);
        cancelAnimationFrame(this.alignFrame);
      }
      update() {
        const visible = this.cards.filter(card => this.activeFilter === 'all' || card.categories.includes(this.activeFilter));
        const visibleSet = new Set(visible);
        this.cards.forEach(card => { card.hidden = !visibleSet.has(card); });
        const sortBy = this.sort.value;
        visible.sort((a, b) => {
          let result = 0;
          if (sortBy === 'price-asc') result = Number(a.dataset.price) - Number(b.dataset.price);
          if (sortBy === 'price-desc') result = Number(b.dataset.price) - Number(a.dataset.price);
          if (sortBy === 'name') result = a.dataset.title.localeCompare(b.dataset.title, document.documentElement.lang || 'es', { sensitivity: 'base', numeric: true });
          return result || Number(a.dataset.order) - Number(b.dataset.order);
        });
        this.filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === this.activeFilter)));
        this.querySelector('[data-count]').textContent = `${visible.length} ${visible.length === 1 ? this.dataset.singular : this.dataset.plural}`;
        this.querySelector('[data-empty]').hidden = visible.length > 0;
        const fragment = document.createDocumentFragment();
        const showPromo = this.promo && this.activeFilter === 'all' && (visible.length > 0 || this.dataset.editorMode === 'true');
        const insertAfter = Math.min(Number(this.dataset.promoAfter) || 4, visible.length);
        if (this.promo) this.promo.hidden = !showPromo;
        visible.forEach((card, index) => { fragment.append(card); if (showPromo && index + 1 === insertAfter) fragment.append(this.promo); });
        if (showPromo && !visible.length) fragment.append(this.promo);
        this.cards.filter(card => !visibleSet.has(card)).forEach(card => fragment.append(card));
        if (this.promo && !showPromo) fragment.append(this.promo);
        this.editorCards.forEach(card => fragment.append(card));
        this.grid.append(fragment);
        this.queueAlign();
      }
      queueAlign() {
        cancelAnimationFrame(this.alignFrame);
        this.alignFrame = requestAnimationFrame(() => {
          if (!this.isConnected) return;
          const visible = this.cards.filter(card => !card.hidden);
          const fields = ['title', 'diet', 'weights', 'price'];
          // Medir de nuevo sin las alturas de la distribución anterior.
          for (const field of fields) {
            this.style.removeProperty(`--cp-${field}-height`);
            for (const card of this.cards) card.style.removeProperty(`--cp-${field}-height`);
          }
          // Alinear únicamente las tarjetas que comparten una fila visual.
          const rows = new Map();
          for (const card of visible) {
            const top = Math.round(card.getBoundingClientRect().top);
            if (!rows.has(top)) rows.set(top, []);
            rows.get(top).push(card);
          }
          const measurements = Array.from(rows.values(), cards => ({
            cards,
            heights: fields.map(field => Math.ceil(Math.max(0, ...cards.map(card =>
              card.querySelector(`[data-align="${field}"]`).getBoundingClientRect().height
            ))))
          }));
          for (const { cards, heights } of measurements) {
            for (const card of cards) fields.forEach((field, index) => {
              card.style.setProperty(`--cp-${field}-height`, `${heights[index]}px`);
            });
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-catalogo-productos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('atelier-product-browser')) {
    customElements.define('atelier-product-browser', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        if (!this.querySelector('[data-empty]')) {
          this.initFrame = requestAnimationFrame(() => { if (this.isConnected) this.connectedCallback(); });
          return;
        }
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.cards = Array.from(this.querySelectorAll('[data-product-card]'));
        this.grid = this.querySelector('[data-grid]');
        this.promo = this.querySelector('[data-promo]');
        this.editorCards = Array.from(this.querySelectorAll('[data-editor-card]'));
        this.filters = Array.from(this.querySelectorAll('[data-filter]'));
        this.sort = this.querySelector('[data-sort]');
        this.activeFilter = 'all';
        this.cards.forEach(card => { card.categories = card.dataset.groups.trim().split(/\s+/).filter(Boolean); });
        this.filters.forEach(button => {
          const count = this.cards.filter(card => button.dataset.filter === 'all' || card.categories.includes(button.dataset.filter)).length;
          button.querySelector('[data-filter-count]').textContent = String(count);
          button.addEventListener('click', () => { this.activeFilter = button.dataset.filter; this.update(); }, { signal });
        });
        this.sort.addEventListener('change', () => this.update(), { signal });
        this.addEventListener('shopify:block:select', event => {
          const target = event.target.closest('[data-product-card], [data-promo]');
          if (target?.hidden) { this.activeFilter = 'all'; this.update(); }
        }, { signal });
        this.querySelector('[data-controls]').hidden = false;
        this.update();
        this.observer = new ResizeObserver(entries => {
          const width = entries[0].contentRect.width;
          if (width !== this.lastWidth) { this.lastWidth = width; this.queueAlign(); }
        });
        this.observer.observe(this);
        if (document.fonts) document.fonts.ready.then(() => { if (!signal.aborted) this.queueAlign(); });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        cancelAnimationFrame(this.initFrame);
        cancelAnimationFrame(this.alignFrame);
      }
      update() {
        const visible = this.cards.filter(card => this.activeFilter === 'all' || card.categories.includes(this.activeFilter));
        const visibleSet = new Set(visible);
        this.cards.forEach(card => { card.hidden = !visibleSet.has(card); });
        const sortBy = this.sort.value;
        visible.sort((a, b) => {
          let result = 0;
          if (sortBy === 'price-asc') result = Number(a.dataset.price) - Number(b.dataset.price);
          if (sortBy === 'price-desc') result = Number(b.dataset.price) - Number(a.dataset.price);
          if (sortBy === 'name') result = a.dataset.title.localeCompare(b.dataset.title, document.documentElement.lang || 'es', { sensitivity: 'base', numeric: true });
          return result || Number(a.dataset.order) - Number(b.dataset.order);
        });
        this.filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === this.activeFilter)));
        this.querySelector('[data-count]').textContent = `${visible.length} ${visible.length === 1 ? this.dataset.singular : this.dataset.plural}`;
        this.querySelector('[data-empty]').hidden = visible.length > 0;
        const fragment = document.createDocumentFragment();
        const showPromo = this.promo && this.activeFilter === 'all' && (visible.length > 0 || this.dataset.editorMode === 'true');
        const insertAfter = Math.min(Number(this.dataset.promoAfter) || 4, visible.length);
        if (this.promo) this.promo.hidden = !showPromo;
        visible.forEach((card, index) => { fragment.append(card); if (showPromo && index + 1 === insertAfter) fragment.append(this.promo); });
        if (showPromo && !visible.length) fragment.append(this.promo);
        this.cards.filter(card => !visibleSet.has(card)).forEach(card => fragment.append(card));
        if (this.promo && !showPromo) fragment.append(this.promo);
        this.editorCards.forEach(card => fragment.append(card));
        this.grid.append(fragment);
        this.queueAlign();
      }
      queueAlign() {
        cancelAnimationFrame(this.alignFrame);
        this.alignFrame = requestAnimationFrame(() => {
          if (!this.isConnected) return;
          const visible = this.cards.filter(card => !card.hidden);
          const fields = ['title', 'diet', 'weights', 'price'];
          // Medir de nuevo sin las alturas de la distribución anterior.
          for (const field of fields) {
            this.style.removeProperty(`--cp-${field}-height`);
            for (const card of this.cards) card.style.removeProperty(`--cp-${field}-height`);
          }
          // Alinear únicamente las tarjetas que comparten una fila visual.
          const rows = new Map();
          for (const card of visible) {
            const top = Math.round(card.getBoundingClientRect().top);
            if (!rows.has(top)) rows.set(top, []);
            rows.get(top).push(card);
          }
          const measurements = Array.from(rows.values(), cards => ({
            cards,
            heights: fields.map(field => Math.ceil(Math.max(0, ...cards.map(card =>
              card.querySelector(`[data-align="${field}"]`).getBoundingClientRect().height
            ))))
          }));
          for (const { cards, heights } of measurements) {
            for (const card of cards) fields.forEach((field, index) => {
              card.style.setProperty(`--cp-${field}-height`, `${heights[index]}px`);
            });
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-chocolateria-inicio"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('atelier-chocolate-intro')) {
  class AtelierChocolateIntro extends HTMLElement {
    connectedCallback() {
      if (this.frame || this.controller) return;
      this.frame = requestAnimationFrame(() => {this.frame = null; if (this.isConnected) this.initialize();});
    }
    initialize() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.media = matchMedia('(max-width: 749px)');
      this.arrange();
      this.media.addEventListener('change', () => this.arrange(), {signal});
      this.addEventListener('click', event => {
        if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        const link = event.target.closest('a[data-anchor]');
        if (!link || !this.contains(link)) return;
        const target = document.getElementById(link.dataset.anchor);
        if (!target) {this.checkTargets(); return;}
        event.preventDefault();
        const offset = Math.max(0, Math.min(400, Number(this.dataset.scrollOffset) || 0));
        const top = Math.max(0, target.getBoundingClientRect().top + window.scrollY - offset);
        const oldTabindex = target.getAttribute('tabindex');
        if (oldTabindex === null) {
          target.setAttribute('tabindex', '-1');
          target.addEventListener('blur', () => {if (target.getAttribute('tabindex') === '-1') target.removeAttribute('tabindex');}, {once: true});
        }
        target.focus({preventScroll: true});
        window.scrollTo({top, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }, {signal});
      if (this.dataset.editor === 'true') {
        this.checkTargets();
        document.addEventListener('shopify:section:load', () => this.checkTargets(), {signal});
        document.addEventListener('shopify:section:unload', () => requestAnimationFrame(() => {if (this.isConnected) this.checkTargets();}), {signal});
        document.addEventListener('shopify:block:select', event => {
          const node = [...this.querySelectorAll('[data-shopify-editor-block]')].find(item => {
            try {return JSON.parse(item.dataset.shopifyEditorBlock).id === event.detail?.blockId;} catch (_) {return false;}
          });
          const list = this.querySelector('[data-links]');
          if (node && list && this.media.matches) list.scrollTo({left: node.offsetLeft - list.offsetLeft, behavior: 'instant'});
        }, {signal});
      }
    }
    arrange() {
      const list = this.querySelector('[data-links]');
      if (!list) return;
      const mobileFirst = this.media.matches && this.dataset.mobilePrimary === 'true';
      const items = [...list.children].sort((a, b) => {
        const priority = mobileFirst ? Number(b.dataset.primary === 'true') - Number(a.dataset.primary === 'true') : 0;
        return priority || Number(a.dataset.order) - Number(b.dataset.order);
      });
      const unchanged = items.every((item, i) => item === list.children[i]);
      if (!unchanged) {
        const active = document.activeElement;
        list.replaceChildren(...items);
        if (this.contains(active)) active.focus({preventScroll: true});
        list.scrollLeft = 0;
      }
    }
    checkTargets() {
      const warning = this.querySelector('[data-anchor-warning]');
      if (!warning) return;
      const missing = [...new Set([...this.querySelectorAll('[data-anchor]')].filter(link => !document.getElementById(link.dataset.anchor)).map(link => link.dataset.anchor))];
      warning.hidden = !missing.length;
      warning.textContent = missing.length ? 'Destinos pendientes en esta página: ' + missing.join(', ') + '. Asigná estos identificadores a las secciones de destino o agregá los marcadores indicados en el archivo Liquid.' : '';
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame); this.frame = null;
      this.controller?.abort(); this.controller = null;
    }
  }
  customElements.define('atelier-chocolate-intro', AtelierChocolateIntro);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-club-perfiles"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('atelier-club-perfiles')) {
  class AtelierClubPerfiles extends HTMLElement {
    connectedCallback() { this.startTimer = setTimeout(() => this.init(), 0); }
    init() {
      if (!this.isConnected || this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.radios = [...this.querySelectorAll('.acp__radio')];
      this.panels = [...this.querySelectorAll('[data-profile-panel]')];
      this.buy = this.querySelector('[data-purchase]');
      this.buyLabel = this.querySelector('[data-purchase-label]');
      this.notice = this.querySelector('[data-unavailable]');
      this.status = this.querySelector('[data-selection-status]');
      this.editorNote = this.querySelector('[data-editor-note]');
      this.profiles = new Map(this.panels.map(panel => [panel.dataset.profilePanel, {
        panel,
        name:panel.dataset.profileName,
        url:this.validURL(panel.dataset.paymentUrl),
        compositionValid:panel.dataset.compositionValid === 'true'
      }]));
      this.radios.forEach(input => { input.disabled = false; });
      this.querySelectorAll('[data-gallery-button]').forEach(button => { button.disabled = false; });
      this.addEventListener('change', event => {
        if (event.target.matches('.acp__radio')) this.selectProfile(event.target.value);
      }, { signal });
      this.addEventListener('click', event => {
        const thumbnail = event.target.closest('[data-gallery-button]');
        if (thumbnail) this.selectImage(thumbnail.dataset.galleryButton);
        const card = event.target.closest('[data-profile-card]');
        if (card && card.querySelector('.acp__radio').checked) this.selectProfile(card.dataset.profileCard);
        if (event.target.closest('[data-purchase]') && !this.purchaseAllowed()) event.preventDefault();
      }, { signal });
      if (this.buy && this.profiles.size) this.selectProfile(this.dataset.initialProfile, false);
      document.addEventListener('shopify:block:select', event => {
        const id = event.detail && event.detail.blockId;
        if (this.profiles.has(id)) this.selectProfile(id);
        else this.selectImage(id);
      }, { signal });
      this.dataset.ready = 'true';
    }
    validURL(value) {
      try {
        const url = new URL((value || '').trim());
        return url.protocol === 'https:' && !url.username && !url.password ? url.href : '';
      } catch (_) { return ''; }
    }
    blockedReason(profile) {
      if (!profile) return 'missing';
      if (!profile.compositionValid) return 'composition';
      if (!profile.url) return 'link';
      if ([...this.profiles.values()].filter(item => item.url === profile.url).length > 1) return 'duplicate';
      return '';
    }
    purchaseAllowed() {
      const profile = this.profiles.get(this.activeId);
      return Boolean(profile && !this.blockedReason(profile) && this.buy.getAttribute('href') === profile.url);
    }
    selectProfile(id, announce = true) {
      const profile = this.profiles.get(id);
      if (!profile || !this.buy) return;
      this.activeId = id;
      this.panels.forEach(panel => { panel.hidden = panel !== profile.panel; });
      this.radios.forEach(input => {
        input.checked = input.value === id;
        input.closest('[data-profile-card]').dataset.active = String(input.checked);
      });
      profile.panel.querySelector('details').open = true;
      const label = `${this.dataset.buyPrefix} ${profile.name}`.trim();
      this.buyLabel.textContent = label;
      this.buy.dataset.selectedProfile = id;
      const reason = this.blockedReason(profile);
      this.buy.removeAttribute('href');
      this.buy.setAttribute('aria-disabled', String(Boolean(reason)));
      if (!reason) this.buy.setAttribute('href', profile.url);
      this.notice.hidden = !reason;
      if (this.editorNote) {
        const messages = {
          composition:'La composición debe sumar exactamente 4 tabletas. Revisá las variedades y cantidades de este perfil.',
          link:`Configurá el enlace HTTPS de la suscripción ${profile.name} en su bloque.`,
          duplicate:'Este enlace está repetido en otro perfil. Cargá el enlace independiente de cada suscripción.'
        };
        this.editorNote.textContent = messages[reason] || '';
        this.editorNote.hidden = !reason;
      }
      if (announce && this.status.textContent !== label) this.status.textContent = label;
    }
    selectImage(id) {
      const figures = [...this.querySelectorAll('[data-gallery-image]')];
      const selected = figures.find(figure => figure.dataset.galleryImage === id);
      if (!selected) return;
      const template = selected.querySelector('[data-gallery-template]');
      if (template) {
        const image = template.content.cloneNode(true);
        image.querySelectorAll('img').forEach(img => { img.loading = 'eager'; });
        template.replaceWith(image);
      }
      figures.forEach(figure => { figure.hidden = figure !== selected; });
      this.querySelectorAll('[data-gallery-button]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.galleryButton === id));
      });
    }
    disconnectedCallback() {
      clearTimeout(this.startTimer);
      this.controller?.abort();
      this.controller = null;
    }
  }
  customElements.define('atelier-club-perfiles', AtelierClubPerfiles);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-coleccion-alfajores"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('atelier-alfajores-collection')) {
  customElements.define('atelier-alfajores-collection', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.view = this.querySelector('[data-alfajores-view]');
      this.status = this.querySelector('[data-alfajores-status]');
      this.errorBox = this.querySelector('[data-alfajores-error]');
      if (!this.view || !this.dataset.sectionId || !this.dataset.collectionUrl) return;
      this.collectionPath = new URL(this.dataset.collectionUrl, location.origin).pathname.replace(/\/$/, '');
      this.currentURL = this.cleanURL(location.href).href;
      this.events = new AbortController();
      const signal = this.events.signal;
      this.enhanceControls();

      this.addEventListener('click', event => {
        if (event.target.closest('[data-alfajores-retry]')) {
          if (this.lastAttempt) this.navigate(this.lastAttempt.url, this.lastAttempt.mode);
          return;
        }
        const link = event.target.closest('a[data-alfajores-nav]');
        if (!link || !this.contains(link) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank' || link.hasAttribute('download')) return;
        const next = this.cleanURL(link.href);
        if (!this.belongsToCollection(next)) return;
        event.preventDefault();
        const sort = this.querySelector('[data-alfajores-sort]');
        if (sort) next.searchParams.set('sort_by', sort.value);
        this.navigate(next);
      }, {signal});

      const sortProducts = () => {
        const sort = this.querySelector('[data-alfajores-sort]');
        if (!sort) return;
        const next = this.cleanURL(this.pendingURL || this.currentURL);
        next.searchParams.set('sort_by', sort.value);
        next.searchParams.delete('page');
        this.navigate(next);
      };
      this.addEventListener('change', event => {
        if (event.target.matches('[data-alfajores-sort]')) sortProducts();
      }, {signal});
      this.addEventListener('submit', event => {
        if (!event.target.matches('[data-alfajores-sort-form]')) return;
        event.preventDefault();
        sortProducts();
      }, {signal});
      window.addEventListener('popstate', () => {
        const next = this.cleanURL(location.href);
        if (this.belongsToCollection(next) && this.urlKey(next) !== this.urlKey(this.currentURL)) {
          this.navigate(next, 'replace');
        } else if (this.pendingURL && this.urlKey(next) === this.urlKey(this.currentURL)) {
          this.cancelRequest();
        }
      }, {signal});
    }

    disconnectedCallback() {
      this.events?.abort();
      this.events = null;
      this.request?.abort();
      this.request = null;
      this.pendingURL = null;
    }

    cleanURL(value) {
      const url = new URL(value, location.origin);
      url.searchParams.delete('section_id');
      url.searchParams.delete('sections');
      return url;
    }

    urlKey(value) {
      const url = this.cleanURL(value);
      return url.origin + url.pathname + url.search;
    }

    belongsToCollection(url) {
      return url.origin === location.origin && (url.pathname === this.collectionPath || url.pathname.startsWith(this.collectionPath + '/'));
    }

    enhanceControls() {
      const current = new URL(location.href);
      for (const link of this.querySelectorAll('a[data-alfajores-nav]')) {
        const next = this.cleanURL(link.href);
        for (const key of ['preview_theme_id', '_fd', 'pb']) {
          if (current.searchParams.has(key)) next.searchParams.set(key, current.searchParams.get(key));
        }
        link.href = next.href;
      }
      const apply = this.querySelector('[data-alfajores-sort-apply]');
      if (apply) apply.hidden = true;
    }

    setBusy(busy) {
      this.toggleAttribute('data-loading', busy);
      this.view.setAttribute('aria-busy', String(busy));
    }

    preserveViewportSpace() {
      const position = {left: window.scrollX, top: window.scrollY};
      const outsideHeight = document.documentElement.scrollHeight - this.getBoundingClientRect().height;
      this.style.minHeight = Math.max(0, position.top + window.innerHeight - outsideHeight) + 'px';
      return position;
    }

    resetSort() {
      const sort = this.querySelector('[data-alfajores-sort]');
      const selected = sort?.querySelector('option[selected]');
      if (selected) sort.value = selected.value;
    }

    cancelRequest() {
      const position = this.preserveViewportSpace();
      this.request?.abort();
      this.request = null;
      this.pendingURL = null;
      this.setBusy(false);
      this.status.textContent = '';
      this.errorBox.hidden = true;
      this.resetSort();
      window.scrollTo({...position, behavior: 'instant'});
    }

    rememberFocus() {
      const active = document.activeElement;
      if (!this.contains(active)) return null;
      if (active.id) return {id: active.id};
      if (active.matches('a[data-alfajores-nav]')) return {url: this.urlKey(active.href)};
      if (active.matches('[data-alfajores-retry]')) return {retry: true};
      return null;
    }

    restoreFocus(focus) {
      if (!focus) return;
      let target;
      if (focus.id) target = [...this.querySelectorAll('[id]')].find(element => element.id === focus.id);
      if (focus.url) target = [...this.querySelectorAll('a[data-alfajores-nav]')].find(link => this.urlKey(link.href) === focus.url);
      if (!target) target = this.querySelector('.ata__pagination [aria-current="page"]') || this.querySelector('a[data-alfajores-nav][aria-current="true"]');
      if (!target) return;
      if (!target.matches('a, button, select, input')) target.setAttribute('tabindex', '-1');
      target.focus({preventScroll: true});
    }

    async navigate(value, mode = 'push') {
      const next = this.cleanURL(value);
      if (!this.belongsToCollection(next)) return;
      if (this.urlKey(next) === this.urlKey(this.currentURL)) {
        this.cancelRequest();
        return;
      }
      this.request?.abort();
      const request = new AbortController();
      this.request = request;
      this.pendingURL = next.href;
      this.lastAttempt = {url: next.href, mode};
      const startPosition = this.preserveViewportSpace();
      this.errorBox.hidden = true;
      this.status.textContent = 'Cargando productos…';
      this.setBusy(true);
      window.scrollTo({...startPosition, behavior: 'instant'});
      let timedOut = false;
      const timeout = window.setTimeout(() => { timedOut = true; request.abort(); }, 20000);

      try {
        const endpoint = new URL(next.href);
        endpoint.searchParams.set('section_id', this.dataset.sectionId);
        const response = await fetch(endpoint.href, {signal: request.signal, credentials: 'same-origin', headers: {'Accept': 'text/html'}});
        if (!response.ok) throw new Error('No se pudo cargar la colección');
        const html = await response.text();
        if (this.request !== request || !this.isConnected) return;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const incoming = parsed.getElementById(this.id);
        const content = incoming?.querySelector('[data-alfajores-view]');
        if (!content) throw new Error('La respuesta no incluye la colección');

        const position = this.preserveViewportSpace();
        const focus = this.rememberFocus();
        if (mode === 'push' && next.href !== location.href) history.pushState(history.state, '', next.href);
        if (mode === 'replace' && next.href !== location.href) history.replaceState(history.state, '', next.href);
        this.view.replaceChildren(...content.childNodes);
        this.currentURL = next.href;
        this.enhanceControls();
        this.restoreFocus(focus);
        window.scrollTo({left: position.left, top: position.top, behavior: 'instant'});
        const count = this.querySelector('.ata__count')?.textContent.trim();
        this.status.textContent = count ? 'Mostrando ' + count + '.' : 'Productos actualizados.';
      } catch (error) {
        if (this.request !== request || !this.isConnected || (error.name === 'AbortError' && !timedOut)) return;
        // Keep the visible collection and its URL together; retry stays on this page.
        if (mode === 'replace') history.replaceState(history.state, '', this.currentURL);
        this.resetSort();
        this.status.textContent = '';
        this.errorBox.hidden = false;
      } finally {
        window.clearTimeout(timeout);
        if (this.request === request) {
          this.request = null;
          this.pendingURL = null;
          this.setBusy(false);
        }
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-coleccion-general"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('atelier-general-collection')) {
  customElements.define('atelier-general-collection', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.view = this.querySelector('[data-general-view]');
      this.status = this.querySelector('[data-general-status]');
      this.errorBox = this.querySelector('[data-general-error]');
      if (!this.view || !this.dataset.sectionId || !this.dataset.collectionUrl) return;
      this.collectionPath = new URL(this.dataset.collectionUrl, location.origin).pathname.replace(/\/$/, '');
      this.currentURL = this.cleanURL(location.href).href;
      this.events = new AbortController();
      const signal = this.events.signal;
      this.enhanceControls();

      this.addEventListener('click', event => {
        if (event.target.closest('[data-general-retry]')) {
          if (this.lastAttempt) this.navigate(this.lastAttempt.url, this.lastAttempt.mode);
          return;
        }
        const link = event.target.closest('a[data-general-nav]');
        if (!link || !this.contains(link) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank' || link.hasAttribute('download')) return;
        const next = this.cleanURL(link.href);
        if (!this.belongsToCollection(next)) return;
        event.preventDefault();
        const sort = this.querySelector('[data-general-sort]');
        if (sort) next.searchParams.set('sort_by', sort.value);
        this.navigate(next);
      }, {signal});

      const sortProducts = () => {
        const sort = this.querySelector('[data-general-sort]');
        if (!sort) return;
        const next = this.cleanURL(this.pendingURL || this.currentURL);
        next.searchParams.set('sort_by', sort.value);
        next.searchParams.delete('page');
        this.navigate(next);
      };
      this.addEventListener('change', event => {
        if (event.target.matches('[data-general-sort]')) sortProducts();
      }, {signal});
      this.addEventListener('submit', event => {
        if (!event.target.matches('[data-general-sort-form]')) return;
        event.preventDefault();
        sortProducts();
      }, {signal});
      window.addEventListener('popstate', () => {
        const next = this.cleanURL(location.href);
        if (this.belongsToCollection(next) && this.urlKey(next) !== this.urlKey(this.currentURL)) {
          this.navigate(next, 'replace');
        } else if (this.pendingURL && this.urlKey(next) === this.urlKey(this.currentURL)) {
          this.cancelRequest();
        }
      }, {signal});
    }

    disconnectedCallback() {
      this.events?.abort();
      this.events = null;
      this.request?.abort();
      this.request = null;
      this.pendingURL = null;
    }

    cleanURL(value) {
      const url = new URL(value, location.origin);
      url.searchParams.delete('section_id');
      url.searchParams.delete('sections');
      return url;
    }

    urlKey(value) {
      const url = this.cleanURL(value);
      return url.origin + url.pathname + url.search;
    }

    belongsToCollection(url) {
      return url.origin === location.origin && (url.pathname === this.collectionPath || url.pathname.startsWith(this.collectionPath + '/'));
    }

    enhanceControls() {
      const current = new URL(location.href);
      for (const link of this.querySelectorAll('a[data-general-nav]')) {
        const next = this.cleanURL(link.href);
        for (const key of ['preview_theme_id', '_fd', 'pb']) {
          if (current.searchParams.has(key)) next.searchParams.set(key, current.searchParams.get(key));
        }
        link.href = next.href;
      }
      const apply = this.querySelector('[data-general-sort-apply]');
      if (apply) apply.hidden = true;
    }

    setBusy(busy) {
      this.toggleAttribute('data-loading', busy);
      this.view.setAttribute('aria-busy', String(busy));
    }

    preserveViewportSpace() {
      const position = {left: window.scrollX, top: window.scrollY};
      const outsideHeight = document.documentElement.scrollHeight - this.getBoundingClientRect().height;
      this.style.minHeight = Math.max(0, position.top + window.innerHeight - outsideHeight) + 'px';
      return position;
    }

    resetSort() {
      const sort = this.querySelector('[data-general-sort]');
      const selected = sort?.querySelector('option[selected]');
      if (selected) sort.value = selected.value;
    }

    cancelRequest() {
      const position = this.preserveViewportSpace();
      this.request?.abort();
      this.request = null;
      this.pendingURL = null;
      this.setBusy(false);
      this.status.textContent = '';
      this.errorBox.hidden = true;
      this.resetSort();
      window.scrollTo({...position, behavior: 'instant'});
    }

    rememberFocus() {
      const active = document.activeElement;
      if (!this.contains(active)) return null;
      if (active.id) return {id: active.id};
      if (active.matches('a[data-general-nav]')) return {url: this.urlKey(active.href)};
      if (active.matches('[data-general-retry]')) return {retry: true};
      return null;
    }

    restoreFocus(focus) {
      if (!focus) return;
      let target;
      if (focus.id) target = [...this.querySelectorAll('[id]')].find(element => element.id === focus.id);
      if (focus.url) target = [...this.querySelectorAll('a[data-general-nav]')].find(link => this.urlKey(link.href) === focus.url);
      if (!target) target = this.querySelector('.atg__pagination [aria-current="page"]') || this.querySelector('a[data-general-nav][aria-current="true"]');
      if (!target) return;
      if (!target.matches('a, button, select, input')) target.setAttribute('tabindex', '-1');
      target.focus({preventScroll: true});
    }

    async navigate(value, mode = 'push') {
      const next = this.cleanURL(value);
      if (!this.belongsToCollection(next)) return;
      if (this.urlKey(next) === this.urlKey(this.currentURL)) {
        this.cancelRequest();
        return;
      }
      this.request?.abort();
      const request = new AbortController();
      this.request = request;
      this.pendingURL = next.href;
      this.lastAttempt = {url: next.href, mode};
      const startPosition = this.preserveViewportSpace();
      this.errorBox.hidden = true;
      this.status.textContent = 'Cargando productos…';
      this.setBusy(true);
      window.scrollTo({...startPosition, behavior: 'instant'});
      let timedOut = false;
      const timeout = window.setTimeout(() => { timedOut = true; request.abort(); }, 20000);

      try {
        const endpoint = new URL(next.href);
        endpoint.searchParams.set('section_id', this.dataset.sectionId);
        const response = await fetch(endpoint.href, {signal: request.signal, credentials: 'same-origin', headers: {'Accept': 'text/html'}});
        if (!response.ok) throw new Error('No se pudo cargar la colección');
        const html = await response.text();
        if (this.request !== request || !this.isConnected) return;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const incoming = parsed.getElementById(this.id);
        const content = incoming?.querySelector('[data-general-view]');
        if (!content) throw new Error('La respuesta no incluye la colección');

        const position = this.preserveViewportSpace();
        const focus = this.rememberFocus();
        if (mode === 'push' && next.href !== location.href) history.pushState(history.state, '', next.href);
        if (mode === 'replace' && next.href !== location.href) history.replaceState(history.state, '', next.href);
        this.view.replaceChildren(...content.childNodes);
        this.currentURL = next.href;
        this.enhanceControls();
        this.restoreFocus(focus);
        window.scrollTo({left: position.left, top: position.top, behavior: 'instant'});
        const count = this.querySelector('.atg__count')?.textContent.trim();
        this.status.textContent = count ? 'Mostrando ' + count + '.' : 'Productos actualizados.';
      } catch (error) {
        if (this.request !== request || !this.isConnected || (error.name === 'AbortError' && !timedOut)) return;
        // Keep the visible collection and its URL together; retry stays on this page.
        if (mode === 'replace') history.replaceState(history.state, '', this.currentURL);
        this.resetSort();
        this.status.textContent = '';
        this.errorBox.hidden = false;
      } finally {
        window.clearTimeout(timeout);
        if (this.request === request) {
          this.request = null;
          this.pendingURL = null;
          this.setBusy(false);
        }
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-coleccion-rama"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('atelier-rama-collection')) {
  customElements.define('atelier-rama-collection', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.view = this.querySelector('[data-rama-view]');
      this.status = this.querySelector('[data-rama-status]');
      this.errorBox = this.querySelector('[data-rama-error]');
      if (!this.view || !this.dataset.sectionId || !this.dataset.collectionUrl) return;
      this.collectionPath = new URL(this.dataset.collectionUrl, location.origin).pathname.replace(/\/$/, '');
      this.currentURL = this.cleanURL(location.href).href;
      this.events = new AbortController();
      const signal = this.events.signal;
      this.enhanceControls();

      this.addEventListener('click', event => {
        if (event.target.closest('[data-rama-retry]')) {
          if (this.lastAttempt) this.navigate(this.lastAttempt.url, this.lastAttempt.mode);
          return;
        }
        const link = event.target.closest('a[data-rama-nav]');
        if (!link || !this.contains(link) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank' || link.hasAttribute('download')) return;
        const next = this.cleanURL(link.href);
        if (!this.belongsToCollection(next)) return;
        event.preventDefault();
        const sort = this.querySelector('[data-rama-sort]');
        if (sort) next.searchParams.set('sort_by', sort.value);
        this.navigate(next);
      }, {signal});

      const sortProducts = () => {
        const sort = this.querySelector('[data-rama-sort]');
        if (!sort) return;
        const next = this.cleanURL(this.pendingURL || this.currentURL);
        next.searchParams.set('sort_by', sort.value);
        next.searchParams.delete('page');
        this.navigate(next);
      };
      this.addEventListener('change', event => {
        if (event.target.matches('[data-rama-sort]')) sortProducts();
      }, {signal});
      this.addEventListener('submit', event => {
        if (!event.target.matches('[data-rama-sort-form]')) return;
        event.preventDefault();
        sortProducts();
      }, {signal});
      window.addEventListener('popstate', () => {
        const next = this.cleanURL(location.href);
        if (this.belongsToCollection(next) && this.urlKey(next) !== this.urlKey(this.currentURL)) {
          this.navigate(next, 'replace');
        } else if (this.pendingURL && this.urlKey(next) === this.urlKey(this.currentURL)) {
          this.cancelRequest();
        }
      }, {signal});
    }

    disconnectedCallback() {
      this.events?.abort();
      this.events = null;
      this.request?.abort();
      this.request = null;
      this.pendingURL = null;
    }

    cleanURL(value) {
      const url = new URL(value, location.origin);
      url.searchParams.delete('section_id');
      url.searchParams.delete('sections');
      return url;
    }

    urlKey(value) {
      const url = this.cleanURL(value);
      return url.origin + url.pathname + url.search;
    }

    belongsToCollection(url) {
      return url.origin === location.origin && (url.pathname === this.collectionPath || url.pathname.startsWith(this.collectionPath + '/'));
    }

    enhanceControls() {
      const current = new URL(location.href);
      for (const link of this.querySelectorAll('a[data-rama-nav]')) {
        const next = this.cleanURL(link.href);
        for (const key of ['preview_theme_id', '_fd', 'pb']) {
          if (current.searchParams.has(key)) next.searchParams.set(key, current.searchParams.get(key));
        }
        link.href = next.href;
      }
      const apply = this.querySelector('[data-rama-sort-apply]');
      if (apply) apply.hidden = true;
    }

    setBusy(busy) {
      this.toggleAttribute('data-loading', busy);
      this.view.setAttribute('aria-busy', String(busy));
    }

    preserveViewportSpace() {
      const position = {left: window.scrollX, top: window.scrollY};
      const outsideHeight = document.documentElement.scrollHeight - this.getBoundingClientRect().height;
      this.style.minHeight = Math.max(0, position.top + window.innerHeight - outsideHeight) + 'px';
      return position;
    }

    resetSort() {
      const sort = this.querySelector('[data-rama-sort]');
      const selected = sort?.querySelector('option[selected]');
      if (selected) sort.value = selected.value;
    }

    cancelRequest() {
      const position = this.preserveViewportSpace();
      this.request?.abort();
      this.request = null;
      this.pendingURL = null;
      this.setBusy(false);
      this.status.textContent = '';
      this.errorBox.hidden = true;
      this.resetSort();
      window.scrollTo({...position, behavior: 'instant'});
    }

    rememberFocus() {
      const active = document.activeElement;
      if (!this.contains(active)) return null;
      if (active.id) return {id: active.id};
      if (active.matches('a[data-rama-nav]')) return {url: this.urlKey(active.href)};
      if (active.matches('[data-rama-retry]')) return {retry: true};
      return null;
    }

    restoreFocus(focus) {
      if (!focus) return;
      let target;
      if (focus.id) target = [...this.querySelectorAll('[id]')].find(element => element.id === focus.id);
      if (focus.url) target = [...this.querySelectorAll('a[data-rama-nav]')].find(link => this.urlKey(link.href) === focus.url);
      if (!target) target = this.querySelector('.atr__pagination [aria-current="page"]') || this.querySelector('a[data-rama-nav][aria-current="true"]');
      if (!target) return;
      if (!target.matches('a, button, select, input')) target.setAttribute('tabindex', '-1');
      target.focus({preventScroll: true});
    }

    async navigate(value, mode = 'push') {
      const next = this.cleanURL(value);
      if (!this.belongsToCollection(next)) return;
      if (this.urlKey(next) === this.urlKey(this.currentURL)) {
        this.cancelRequest();
        return;
      }
      this.request?.abort();
      const request = new AbortController();
      this.request = request;
      this.pendingURL = next.href;
      this.lastAttempt = {url: next.href, mode};
      const startPosition = this.preserveViewportSpace();
      this.errorBox.hidden = true;
      this.status.textContent = 'Cargando productos…';
      this.setBusy(true);
      window.scrollTo({...startPosition, behavior: 'instant'});
      let timedOut = false;
      const timeout = window.setTimeout(() => { timedOut = true; request.abort(); }, 20000);

      try {
        const endpoint = new URL(next.href);
        endpoint.searchParams.set('section_id', this.dataset.sectionId);
        const response = await fetch(endpoint.href, {signal: request.signal, credentials: 'same-origin', headers: {'Accept': 'text/html'}});
        if (!response.ok) throw new Error('No se pudo cargar la colección');
        const html = await response.text();
        if (this.request !== request || !this.isConnected) return;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const incoming = parsed.getElementById(this.id);
        const content = incoming?.querySelector('[data-rama-view]');
        if (!content) throw new Error('La respuesta no incluye la colección');

        const position = this.preserveViewportSpace();
        const focus = this.rememberFocus();
        if (mode === 'push' && next.href !== location.href) history.pushState(history.state, '', next.href);
        if (mode === 'replace' && next.href !== location.href) history.replaceState(history.state, '', next.href);
        this.view.replaceChildren(...content.childNodes);
        this.currentURL = next.href;
        this.enhanceControls();
        this.restoreFocus(focus);
        window.scrollTo({left: position.left, top: position.top, behavior: 'instant'});
        const count = this.querySelector('.atr__count')?.textContent.trim();
        this.status.textContent = count ? 'Mostrando ' + count + '.' : 'Productos actualizados.';
      } catch (error) {
        if (this.request !== request || !this.isConnected || (error.name === 'AbortError' && !timedOut)) return;
        // Keep the visible collection and its URL together; retry stays on this page.
        if (mode === 'replace') history.replaceState(history.state, '', this.currentURL);
        this.resetSort();
        this.status.textContent = '';
        this.errorBox.hidden = false;
      } finally {
        window.clearTimeout(timeout);
        if (this.request === request) {
          this.request = null;
          this.pendingURL = null;
          this.setBusy(false);
        }
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-cuatro-tabletas"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('atelier-tabletas')) {
    customElements.define('atelier-tabletas', class extends HTMLElement {
      connectedCallback() {
        this.startFrame = requestAnimationFrame(() => this.setup());
      }

      setup() {
        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        if (!this.track || !this.slides.length) return;
        this.controls = this.querySelector('[data-controls]');
        this.previous = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        this.counter = this.querySelector('[data-counter]');
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.mobile = matchMedia('(max-width: 749px)');
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.index = 0;

        this.previous?.addEventListener('click', () => this.goTo(this.index - 1), options);
        this.next?.addEventListener('click', () => this.goTo(this.index + 1), options);
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.update());
        }, { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          if (!this.mobile.matches || event.target !== this.track) return;
          const positions = { ArrowLeft: this.index - 1, ArrowRight: this.index + 1, Home: 0, End: this.slides.length - 1 };
          if (!(event.key in positions)) return;
          event.preventDefault();
          this.goTo(positions[event.key]);
        }, options);
        this.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index !== -1 && this.mobile.matches) this.goTo(index, false);
        }, options);
        this.mobile.addEventListener('change', () => this.layout(), options);
        this.observer = new ResizeObserver(() => {
          if (this.lastWidth === this.track.clientWidth) return;
          this.lastWidth = this.track.clientWidth;
          if (this.mobile.matches) this.goTo(this.index, false);
          this.update();
        });
        this.observer.observe(this.track);
        this.setAttribute('data-enhanced', '');
        this.layout();
      }

      layout() {
        this.track.tabIndex = this.mobile.matches && this.slides.length > 1 ? 0 : -1;
        if (this.controls) this.controls.hidden = !this.mobile.matches;
        if (!this.mobile.matches) {
          this.track.scrollLeft = 0;
          this.index = 0;
        }
        this.update();
      }

      goTo(index, animate = true) {
        if (!this.mobile.matches) return;
        const target = this.slides[Math.max(0, Math.min(index, this.slides.length - 1))];
        this.track.scrollTo({ left: target.offsetLeft, behavior: animate && !this.reducedMotion.matches ? 'smooth' : 'instant' });
      }

      update() {
        if (!this.mobile.matches || !this.counter) return;
        const left = this.track.scrollLeft;
        this.index = this.slides.reduce((nearest, slide, i) => Math.abs(slide.offsetLeft - left) < Math.abs(this.slides[nearest].offsetLeft - left) ? i : nearest, 0);
        const label = (this.index + 1) + ' de ' + this.slides.length;
        if (this.counter.textContent !== label) this.counter.textContent = label;
        this.previous.disabled = this.index === 0;
        this.next.disabled = this.index === this.slides.length - 1;
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.startFrame);
        cancelAnimationFrame(this.scrollFrame);
        this.abort?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-empresas-cotizador"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('atelier-business-quote')) {
  class AtelierBusinessQuote extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.select = this.querySelector('[data-gift-select]');
      this.variantSelect = this.querySelector('[data-variant-select]');
      this.flavorSelect = this.querySelector('[data-flavor-select]');
      this.quantity = this.querySelector('[data-quantity]');
      this.date = this.querySelector('[data-date]');
      this.urgent = this.querySelector('[data-urgent-request]');
      this.delivery = this.querySelector('[data-delivery]');
      this.requestLink = this.querySelector('[data-request]');
      this.confirmLabel = this.requestLink.dataset.defaultLabel || this.requestLink.textContent;
      this.downloadButton = this.querySelector('[data-download]');
      this.currency = ['UYU', 'USD'].includes(this.dataset.currency) ? this.dataset.currency : 'UYU';
      this.formatter = new Intl.NumberFormat('es-UY', {style: 'currency', currency: this.currency, currencyDisplay: 'code', minimumFractionDigits: 0, maximumFractionDigits: 2});
      this.gifts = new Map([...this.querySelectorAll('[data-gift]')].map(card => {
        const min = this.integer(card.dataset.min, 1, 100000);
        const step = this.integer(card.dataset.step, 1, 100000);
        const gift = {id: card.dataset.gift, card, flavors:this.parseFlavors(card.dataset.flavors), key: card.dataset.giftKey || '', title: card.querySelector('.bq__gift-title').textContent.trim(), min, step, max: min + Math.floor((100000 - min) / step) * step, image: card.dataset.image || '', alt: card.dataset.imageAlt || '', variants: [], ...this.readPricing(card)};
        return [gift.id, gift];
      }));
      this.variants = new Map();
      const byKey = new Map();
      for (const gift of this.gifts.values()) {
        const matches = byKey.get(gift.key) || [];
        matches.push(gift); byKey.set(gift.key, matches);
      }
      let configurationWarning = [...byKey].some(([key, matches]) => !key || matches.length > 1);
      for (const node of this.querySelectorAll('[data-variant-block]')) {
        const matches = byKey.get(node.dataset.giftKey);
        if (!node.dataset.giftKey || matches?.length !== 1) {configurationWarning = true; continue;}
        const gift = matches[0];
        gift.hasConfiguredVariants = true;
        if (node.dataset.enabled === 'false') continue;
        const min = this.integer(node.dataset.min, 0, 100000) || gift.min;
        const step = this.integer(node.dataset.step, 0, 100000) || gift.step;
        const variant = {id: node.dataset.variantBlock, giftId: gift.id, image:node.dataset.image||'',alt:node.dataset.imageAlt||'',picture:node.querySelector('[data-variant-picture]'), title: node.dataset.title.trim() || 'Variante', min, step, max: min + Math.floor((100000 - min) / step) * step, ...this.readPricing(node)};
        this.variants.set(variant.id, variant);
        gift.variants.push(variant);
      }
      // Un regalo con todas sus variantes desactivadas no vuelve a usar un precio base.
      for (const [id, gift] of this.gifts) {
        if (gift.card.dataset.enabled !== 'false' && (!gift.hasConfiguredVariants || gift.variants.length)) continue;
        gift.card.hidden = true;
        this.gifts.delete(id);
        for (const option of [...this.select.options]) if (option.value === id) option.remove();
        for (const variant of gift.variants) this.variants.delete(variant.id);
      }
      const variantWarning = this.querySelector('[data-variant-warning]');
      if (variantWarning) variantWarning.hidden = !configurationWarning;
      this.setupGiftCards();
      this.extraOptions = new Map([...this.querySelectorAll('[data-extra]')].map(label => [label.dataset.extra, {id: label.dataset.extra, label, title: label.querySelector('[data-extra-title]').textContent.trim(), unit: this.parsePrice(label.dataset.unit), fixed: this.parsePrice(label.dataset.fixed), enabled:label.dataset.enabled!=='false', giftKeys:(label.dataset.giftKeys||'').split(/[\s,;]+/).filter(Boolean), urgent:label.dataset.urgent!=='false', max:this.integer(label.dataset.max,1,100)}]));
      this.phone = (this.dataset.phone || '').replace(/\D/g, '');
      this.email = (this.dataset.email || '').trim();
      this.contactReady = this.dataset.contactMode === 'email' ? /^[^\s@?&#]+@[^\s@?&#]+\.[^\s@?&#]+$/.test(this.email) : /^\d{10,15}$/.test(this.phone);
      this.requestLink.hidden = !this.contactReady;
      const contactPreview = this.querySelector('[data-editor-contact]');
      const contactNote = this.querySelector('[data-contact-note]');
      if (contactPreview) contactPreview.hidden = this.contactReady;
      if (contactNote) contactNote.hidden = this.contactReady;
      this.querySelector('[data-calculator]').hidden = this.gifts.size === 0;
      this.querySelector('[data-unavailable]').hidden = this.gifts.size !== 0;
      this.setupStarter(signal);
      if (!this.gifts.size) return;
      this.instructions = this.querySelector('[data-instructions]');
      this.addButton = this.querySelector('[data-add]');
      this.basket = this.querySelector('[data-basket]');
      this.storageKey = 'atelier-corporate-quote:v2:' + location.pathname + ':' + this.id;
      this.lineSequence = 0;
      const old = this.previous || this.readSaved();
      this.selectionSource = this.gifts.has(old.gift) && ['grid', 'quote'].includes(old.selectionSource) ? old.selectionSource : 'hero';
      this.items = this.restoreItems(old.items);
      this.editingId = this.items.some(item => item.id === old.editingId) ? old.editingId : null;
      this.addEventListener('click', event => {
        const choice = event.target.closest('[data-choose]');
        if (choice && this.contains(choice)) {event.preventDefault(); this.selectionSource = 'grid'; this.choose(choice.dataset.choose, true, this.gifts.get(choice.dataset.choose)?.cardVariantId,this.gifts.get(choice.dataset.choose)?.cardFlavor);}
        if (event.target.closest('[data-minus]')) this.changeQuantity(-1);
        if (event.target.closest('[data-plus]')) this.changeQuantity(1);
        if (event.target.closest('[data-add]')) this.addItem();
        if (event.target.closest('[data-cancel-edit]')) this.cancelEdit();
        const edit = event.target.closest('[data-edit-line]');
        const remove = event.target.closest('[data-remove-line]');
        if (edit) this.editItem(edit.dataset.editLine);
        if (remove) this.removeItem(remove.dataset.removeLine);
        if (event.target.closest('[data-download]')) this.download();
        if (event.target.closest('[data-pay-deposit]')) this.payDeposit();
        if (event.target.closest('[data-export-catalog]')) this.exportCatalog();
        if (event.target.closest('[data-request]') && !this.canExport()) event.preventDefault();
      }, {signal});
      this.addEventListener('input', event => {
        if ([this.quantity, this.date, this.instructions].includes(event.target) || event.target.matches('[data-extra-count]')) this.update();
      }, {signal});
      this.addEventListener('change', event => {
        const cardFlavor=event.target.closest('[data-card-flavor]');
        if(cardFlavor && this.contains(cardFlavor)) {
          const gift=this.gifts.get(cardFlavor.dataset.cardFlavor);
          if(this.busy||!gift||!gift.flavors.includes(cardFlavor.value))return;
          this.selectionSource='grid';this.choose(gift.id,false,gift.cardVariantId,cardFlavor.value);
          this.announce('Selección enviada al cotizador: '+gift.title+' · Sabor: '+this.selectedFlavor+'.');
          return;
        }
        const cardSelect=event.target.closest('[data-card-variant]');
        if(cardSelect && this.contains(cardSelect)) {
          const gift=this.gifts.get(cardSelect.dataset.cardVariant);
          if(this.busy||!gift||!gift.variants.some(v=>v.id===cardSelect.value))return;
          this.selectionSource='grid';this.choose(gift.id,false,cardSelect.value);
          this.announce('Selección enviada al cotizador: '+gift.title+' · '+this.selectedVariant.title+'.');
        }
        else if (event.target === this.select) {this.selectionSource = 'quote'; this.choose(this.select.value, false);}
        else if (event.target === this.flavorSelect) {if(this.busy)return;this.selectionSource='quote';this.setFlavor(this.flavorSelect.value);this.update();this.announce('Sabor seleccionado: '+this.selectedFlavor+'.');}
        else if (event.target === this.variantSelect) {this.selectionSource = 'quote'; this.chooseVariant(this.variantSelect.value);}
        else if ([this.quantity, this.date, this.delivery, this.instructions, this.urgent].includes(event.target) || event.target.matches('.bq__radio,[data-extra-count]')) this.update();
      }, {signal});
      this.querySelector('[data-form]').addEventListener('submit', event => event.preventDefault(), {signal});
      document.addEventListener('shopify:block:select', event => {
        const id = event.detail?.blockId;
        if (this.gifts.has(id)) this.choose(id, false);
        else if (this.variants.has(id)) this.choose(this.variants.get(id).giftId, false, id);
        else if (this.extraOptions.has(id)) {this.extraOptions.get(id).label.querySelector('input').checked = true; this.update();}
        else if ([...this.delivery.options].some(option => option.value === id)) {this.delivery.value = id; this.update();}
      }, {signal});
      document.addEventListener('visibilitychange', () => {if (!document.hidden && this.selected) this.update();}, {signal});
      for (const button of this.querySelectorAll('[data-choose]')) button.disabled = !this.gifts.has(button.dataset.choose);
      this.quantity.value = old.quantity || this.integer(this.dataset.initialQuantity, 1, 100000);
      this.instructions.value = this.cleanNotes(old.notes);
      this.urgent.checked = old.urgent === true;
      this.date.value = typeof old.date === 'string' ? old.date : '';
      if ([...this.delivery.options].some(option => option.value === old.delivery)) this.delivery.value = old.delivery;
      const initial = [...this.gifts.values()].find(gift => gift.card.dataset.initial === 'true') || this.gifts.values().next().value;
      this.choose(this.gifts.has(old.gift) ? old.gift : initial.id, false, old.variantId,old.flavor);
      this.restoreExtraChoices(old.extras || (old.extra ? [{id:old.extra,count:1}] : []));
      this.update();
      this.dataset.enhanced = 'true';
    }
    disconnectedCallback() {
      this.previous = {selectionSource: this.selectionSource, items: this.items, editingId: this.editingId, gift: this.selected?.id, variantId: this.selectedVariant?.id || '', flavor:this.selectedFlavor||'', quantity: this.quantity?.value, extras: this.chosenExtras(), urgent:this.urgent.checked, notes: this.instructions?.value, date: this.date?.value, delivery: this.delivery?.value};
      this.controller?.abort();
      this.controller = null;
      this.renderedBasket = null;
    }
    setupStarter(signal) {
      this.starter = this.querySelector('[data-starter]');
      const contact = this.querySelector('[data-hero-whatsapp]');
      const phoneReady = /^\d{10,15}$/.test(this.phone);
      if (contact) {
        contact.hidden = !phoneReady;
        if (phoneReady) contact.href = 'https://wa.me/' + this.phone;
      }
      const contactNote = this.querySelector('[data-hero-contact-note]');
      if (contactNote) contactNote.hidden = phoneReady;
      if (!this.starter) return;
      this.starterGift = this.querySelector('[data-starter-gift]');
      this.starterQuantity = this.querySelector('[data-starter-quantity]');
      this.starterDate = this.querySelector('[data-starter-date]');
      this.starterStatus = this.querySelector('[data-starter-status]');
      this.starterGift.replaceChildren(...[...this.gifts.values()].map(gift => {
        const option = document.createElement('option'); option.value = gift.id; option.textContent = gift.title; return option;
      }));
      this.querySelector('[data-starter-fields]').disabled = !this.gifts.size;
      if (!this.gifts.size) this.starterStatus.textContent = 'Estamos actualizando nuestras propuestas. Consultanos para preparar tu presupuesto.';
      this.querySelector('[data-starter-urgent]').addEventListener('change',event=>{this.urgent.checked=event.target.checked;this.update();},{signal});
      this.starter.addEventListener('input', event => {
        if (event.target === this.starterQuantity || event.target === this.starterDate) this.applyStarter(false);
      }, {signal});
      this.starter.addEventListener('change', event => {
        if ([this.starterGift, this.starterQuantity, this.starterDate].includes(event.target)) this.applyStarter(false);
      }, {signal});
      this.starter.addEventListener('submit', event => {
        event.preventDefault();
        if (!this.applyStarter(true)) return;
        this.querySelector('[data-grid-heading]')?.focus({preventScroll: true});
        this.querySelector('.bq__gifts').scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
      }, {signal});
    }
    syncStarter() {
      if (!this.starter || !this.selected) return;
      const option = this.selectedVariant || this.selected;
      const locked = ['grid', 'quote'].includes(this.selectionSource);
      this.querySelector('[data-starter-fields]').disabled = Boolean(this.editingId);
      this.starterGift.disabled = locked;
      this.starterGift.value = this.selected.id;
      this.starterQuantity.value = this.quantity.value;
      this.starterQuantity.min = option.min;
      this.starterQuantity.max = option.max;
      this.starterQuantity.step = option.step;
      this.starterDate.value = this.date.value;
      this.starterDate.min = this.date.min;
      this.querySelector('[data-starter-urgent]').checked=this.urgent.checked;
      this.starterQuantity.setAttribute('aria-invalid', this.quantity.getAttribute('aria-invalid') || 'false');
      this.starterDate.setAttribute('aria-invalid', this.date.getAttribute('aria-invalid') || 'false');
      this.starterStatus.dataset.error = 'false';
      this.starterStatus.textContent = this.editingId ? 'Guardá o cancelá la edición en el cotizador para volver a usar este formulario.' : locked ? 'Tu elección actual es ' + this.selected.title + '. Para cambiar el regalo, usá las tarjetas o el cotizador. Cantidad y fecha se mantienen sincronizadas.' : this.date.value && this.draft?.valid ? 'Datos cargados en el cotizador. Podés revisar los regalos antes de agregar al presupuesto.' : '';
    }
    applyStarter(report) {
      if (!this.starter || !this.selected || this.editingId) return false;
      // Después de usar la grilla o el cotizador, el formulario inicial no puede
      // reponer una selección antigua ni modificar una variante elegida abajo.
      const locked = ['grid', 'quote'].includes(this.selectionSource);
      const gift = locked ? this.selected : this.gifts.get(this.starterGift.value);
      if (!gift) return false;
      const option = gift.id === this.selected.id ? (this.selectedVariant || gift) : (gift.variants[0] || gift);
      this.starterQuantity.min = option.min;
      this.starterQuantity.max = option.max;
      this.starterQuantity.step = option.step;
      this.starterDate.min = this.date.min;
      const qty = Number(this.starterQuantity.value);
      const quantityValid = this.starterQuantity.value !== '' && !this.starterQuantity.validity.badInput && this.validQuantity(qty, option);
      const dateValid = Boolean(this.starterDate.value) && this.starterDate.checkValidity();
      this.starterQuantity.setAttribute('aria-invalid', String(!quantityValid));
      this.starterDate.setAttribute('aria-invalid', String(!dateValid));
      if (!quantityValid || !dateValid) {
        this.starterStatus.dataset.error = 'true';
        this.starterStatus.textContent = !quantityValid ? 'Ingresá entre ' + option.min + ' y ' + option.max + ' unidades, en incrementos de ' + option.step + ' desde ' + option.min + '.' : 'Elegí una fecha a partir del ' + this.displayDate(this.date.min) + ' para cargar los datos.';
        if (report) (!quantityValid ? this.starterQuantity : this.starterDate).reportValidity();
        return false;
      }
      this.quantity.value = String(qty);
      this.date.value = this.starterDate.value;
      if (!locked) this.selectionSource = 'hero';
      this.choose(gift.id, false);
      return true;
    }

    chosenExtras() {
      return [...this.extraOptions.values()].filter(e => e.label.querySelector('input[type="checkbox"]')?.checked)
        .map(e => ({id:e.id, count:Number(e.label.querySelector('[data-extra-count]').value)}));
    }
    restoreExtraChoices(values, gift = this.selected) {
      const rows = Array.isArray(values) ? values : [];
      for (const e of this.extraOptions.values()) {
        const saved = rows.find(row => row.id === e.id);
        e.label.querySelector('input[type="checkbox"]').checked = Boolean(saved && this.extraAllowed(e, gift));
        e.label.querySelector('[data-extra-count]').value = Number.isInteger(saved?.count) ? Math.max(1,Math.min(e.max,saved.count)) : 1;
      }
    }
    extraAllowed(extra, gift, urgent = this.urgent?.checked) {
      return Boolean(extra && extra.enabled && gift && (!extra.giftKeys.length || extra.giftKeys.includes(gift.key)) && (!urgent || extra.urgent));
    }
    normalizeExtras(item) {
      const choices = Array.isArray(item.extras) ? item.extras : item.extraId && item.extraId !== 'none' ? [{id:item.extraId,count:1}] : [];
      return choices.map(e => ({id:String(e.id),count:Number(e.count)}));
    }
    validExtras(choices, gift, urgent = this.urgent?.checked) {
      return Array.isArray(choices) && new Set(choices.map(e=>e.id)).size === choices.length && choices.every(row => {
        const extra=this.extraOptions.get(row.id);
        return this.extraAllowed(extra,gift,urgent) && Number.isInteger(row.count) && row.count>=1 && row.count<=extra.max;
      });
    }
    todayKey() {
      const parts=new Intl.DateTimeFormat('en-CA',{timeZone:'America/Montevideo',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
      const part=t=>parts.find(p=>p.type===t).value;
      return part('year')+'-'+part('month')+'-'+part('day');
    }
    normalDate() {
      const date=new Date(this.todayKey()+'T12:00:00Z');
      const holidays=(this.dataset.holidays||'').split(/[\s,;]+/);
      let left=this.integer(this.dataset.leadDays,0,3650);
      while(left>0){date.setUTCDate(date.getUTCDate()+1);const key=date.toISOString().slice(0,10);if(this.dataset.leadMode!=='business'||(![0,6].includes(date.getUTCDay())&&!holidays.includes(key)))left--;}
      return date.toISOString().slice(0,10);
    }
    termsText() {return this.querySelector('[data-terms-text]').textContent.trim();}
    customerData() {
      return Object.fromEntries([...this.querySelectorAll('[data-customer-field]')].map(el=>[el.dataset.customerField,el.value.trim()]));
    }
    customerLabel(key) {return {name:'Nombre',email:'Correo',phone:'Teléfono',company:'Empresa',address:'Dirección / entrega'}[key]||key;}
    checkoutReady() {
      return this.canExport() && !this.state.customRequired && Number.isSafeInteger(this.state.total) && this.state.total>0 && Boolean(this.date.value) && !this.busy;
    }
    endpoint() {
      const raw=(this.dataset.quoteEndpoint||'').trim();
      if(!/^\/apps\/[a-zA-Z0-9/_-]+$/.test(raw)) return '';
      return raw.replace(/\/$/,'');
    }
    async digest(value) {return [...new Uint8Array(await crypto.subtle.digest('SHA-256',new TextEncoder().encode(value)))].map(x=>x.toString(16).padStart(2,'0')).join('');}
    catalogConfig() {
      const pricing=o=>({id:o.id,title:o.title,min:o.min,step:o.step,max:o.max,unit:o.unit,tiers:o.tiers,customFrom:o.customFrom});
      return {version:1,merchantIdentity:this.dataset.merchantIdentity||'',currency:this.currency,leadDays:this.integer(this.dataset.leadDays,0,3650),leadMode:this.dataset.leadMode,holidays:(this.dataset.holidays||'').split(/[\s,;]+/).filter(Boolean),termsVersion:this.dataset.termsVersion,terms:this.termsText(),taxNote:this.dataset.taxNote||'',
        gifts:[...this.gifts.values()].map(g=>({...pricing(g),key:g.key,variants:g.variants.map(pricing)})),
        extras:[...this.extraOptions.values()].filter(e=>e.enabled).map(e=>({id:e.id,title:e.title,unit:e.unit,fixed:e.fixed,max:e.max,giftKeys:e.giftKeys,urgent:e.urgent})),
        deliveries:[...this.delivery.options].map(o=>({id:o.value,title:o.textContent.trim(),price:this.parsePrice(o.dataset.price)}))};
    }
    exportCatalog() {
      if(this.dataset.editor!=='true')return;
      this.saveBlob(new Blob([JSON.stringify(this.catalogConfig(),null,2)],{type:'application/json'}),'catalogo-cotizador.json');
    }
    saveBlob(blob,name) {const u=URL.createObjectURL(blob),a=document.createElement('a');a.href=u;a.download=name;a.click();setTimeout(()=>URL.revokeObjectURL(u),60000);}
    async api(path,body) {
      const response=await fetch(this.endpoint()+path,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body),signal:AbortSignal.timeout(25000)});
      const data=await response.json();
      if(!response.ok)throw new Error(data.message||'No pudimos registrar el presupuesto. No se inició ningún pago.');
      return data;
    }
    async registeredQuote() {
      if(this.items.some(item=>!this.validFlavorLine(item)))throw new Error('Revisá el sabor y las indicaciones de cada línea antes de continuar.');
      const payload={catalogHash:await this.digest(JSON.stringify(this.catalogConfig())),items:this.items.map(item=>({giftId:item.giftId,variantId:item.variantId,qty:item.qty,extras:item.extras,notes:this.notesForServer(item)})),date:this.date.value,deliveryId:this.delivery.value,urgent:this.urgent.checked,customer:this.customerData()};
      const fingerprint=JSON.stringify(payload);
      if(this.remoteQuote?.fingerprint===fingerprint)return this.remoteQuote;
      if(this.remoteRequest?.fingerprint!==fingerprint)this.remoteRequest={fingerprint,key:crypto.randomUUID()};
      const result=await this.api('/quotes',{...payload,requestKey:this.remoteRequest.key});
      if(result.total!==this.state.total||result.deposit!==Math.ceil(this.state.total/2))throw new Error('El precio validado cambió. Actualizá la página y revisá el presupuesto antes de pagar.');
      if(!/^[a-zA-Z0-9-]+$/.test(result.quoteId)||typeof result.token!=='string')throw new Error('Respuesta de registro inválida.');
      this.remoteQuote={...result,fingerprint};
      return this.remoteQuote;
    }
    async remoteDownload() {
      const quote=await this.registeredQuote();
      const response=await fetch(this.endpoint()+'/quotes/'+quote.quoteId+'/pdf?token='+encodeURIComponent(quote.token),{signal:AbortSignal.timeout(25000)});
      if(!response.ok)throw new Error('No se pudo descargar el presupuesto registrado.');
      this.saveBlob(await response.blob(),'presupuesto-'+quote.quoteId+'.pdf');
      this.announce('Presupuesto registrado '+quote.quoteId+' descargado. Es la misma versión asociada al pago.');
    }
    async payDeposit() {
      this.update();
      if(!this.endpoint()||!this.checkoutReady())return;
      const fields=[...this.querySelectorAll('[data-customer-field]')];
      for(const field of fields){if(!field.reportValidity())return;}
      const acceptance=this.querySelector('[data-accept-terms]');
      if(!acceptance.checked){acceptance.focus();this.showActionError('Leé y aceptá las condiciones antes de continuar.');return;}
      this.setBusy(true);
      try {
        const quote=await this.registeredQuote();
        const result=await this.api('/quotes/'+quote.quoteId+'/checkout',{token:quote.token,accepted:true,termsVersion:this.dataset.termsVersion});
        const url=new URL(result.checkoutUrl);
        const allowed=[location.hostname,new URL(this.dataset.site).hostname,'checkout.shopify.com',this.dataset.shopDomain];
        if(url.protocol!=='https:'||!allowed.includes(url.hostname))throw new Error('El destino del checkout no es válido.');
        location.assign(url.href);
      }catch(error){this.showActionError(error.name==='TimeoutError'?'La respuesta está demorada. Reintentá: se recuperará la misma solicitud, sin duplicar la seña.':error.message);}
      finally{this.setBusy(false);}
    }
    showActionError(text){const el=this.querySelector('[data-action-error]');el.textContent=text;el.hidden=false;}
    setBusy(value){this.busy=value;this.querySelectorAll('[data-form] input,[data-form] select,[data-form] textarea,[data-form] button,[data-customer-field],[data-accept-terms],[data-edit-line],[data-remove-line],[data-choose],[data-card-variant],[data-card-flavor],[data-starter-fields],[data-starter-urgent]').forEach(el=>{if(value){el.dataset.wasDisabled=String(el.disabled);el.disabled=true;}else{el.disabled=el.dataset.wasDisabled==='true';delete el.dataset.wasDisabled;}});this.querySelector('[data-pay-deposit]').disabled=value||!this.checkoutReady()||!this.endpoint();this.downloadButton.disabled=value||!this.canExport()||this.state.customRequired;}

    cleanNotes(value) {return typeof value === 'string' ? value.replace(/[\u0000-\u0008\u000b-\u001f\u007f]/g, '').slice(0, 300).trim() : '';}
    readSaved() {
      if (this.dataset.editor === 'true') return {};
      try {
        const saved = JSON.parse(sessionStorage.getItem(this.storageKey) || '{}');
        return [2, 3, 4, 5, 6].includes(saved?.version) && Array.isArray(saved.items) ? saved : {};
      } catch (_) {return {};}
    }
    restoreItems(items) {
      if (!Array.isArray(items)) return [];
      const totals = new Map(), ids = new Set();
      const restored = [];
      for (const item of items.slice(0, 50)) {
        if (!item || typeof item !== 'object') continue;
        const gift = this.gifts.get(item.giftId);
        const variantId = typeof item.variantId === 'string' ? item.variantId : '';
        const option = this.optionFor(gift, variantId);
        const selections=this.normalizeExtras(item);
        if (!option || !this.validExtras(selections,gift,false) || !this.validQuantity(item.qty, option)) continue;
        const qty = (totals.get(item.giftId) || 0) + item.qty;
        if (qty > 100000) continue;
        totals.set(item.giftId, qty);
        let id = /^line-\d+$/.test(item.id) && !ids.has(item.id) ? item.id : null;
        if (id) this.lineSequence = Math.max(this.lineSequence, Number(id.slice(5)));
        else id = 'line-' + (++this.lineSequence);
        ids.add(id);
        restored.push({id, giftId: item.giftId, variantId, flavor:typeof item.flavor==='string'?item.flavor:'', extras: selections, qty: item.qty, notes: this.cleanNotes(item.notes)});
      }
      if (restored.length !== items.length) {
        const note = this.querySelector('[data-restore-note]');
        note.hidden = false;
        note.textContent = 'Algunas opciones cambiaron desde tu visita anterior. Revisá los regalos y volvé a agregar los que falten.';
      }
      return restored;
    }
    saveItems() {
      if (this.dataset.editor === 'true') return;
      try {sessionStorage.setItem(this.storageKey, JSON.stringify({version: 6, items: this.items, date: this.date.value, delivery: this.delivery.value, gift: this.selected?.id, variantId: this.selectedVariant?.id || '', flavor:this.selectedFlavor||'', quantity: this.quantity.value, extras: this.chosenExtras(), urgent:this.urgent.checked, notes: this.instructions.value, editingId: this.editingId, selectionSource: this.selectionSource}));} catch (_) {/* El cotizador sigue funcionando sin almacenamiento. */}
    }
    validQuantity(qty, gift) {return Number.isInteger(qty) && qty >= gift.min && qty <= gift.max && (qty - gift.min) % gift.step === 0;}
    canExport() {return Boolean(this.state?.valid && !this.editingId);}
    announce(message) {this.querySelector('[data-status]').textContent = message;}
    addItem() {
      this.update();
      if (!this.draft.valid) return;
      const replacing = Boolean(this.editingId);
      const row = {id: this.editingId || 'line-' + (++this.lineSequence), giftId: this.selected.id, variantId: this.selectedVariant?.id || '', flavor:this.selectedFlavor||'', qty: this.draft.qty, extras: this.draft.extras, notes: this.cleanNotes(this.instructions.value)};
      if (replacing) this.items = this.items.map(item => item.id === row.id ? row : item);
      else this.items.push(row);
      this.editingId = null;
      this.instructions.value = '';
      this.update();
      this.announce((replacing ? 'Cambios guardados. ' : 'Regalo agregado. ') + this.state.qty + ' regalos en el presupuesto.');
    }
    editItem(id) {
      const item = this.items.find(row => row.id === id);
      if (!item) return;
      this.editingId = id;
      this.selectionSource = 'quote';
      this.quantity.value = item.qty;
      this.instructions.value = item.notes;
      this.choose(item.giftId, true, item.variantId,item.flavor);
      this.restoreExtraChoices(this.normalizeExtras(item));
      this.update();
      this.announce('Editando ' + this.selected.title + (this.selectedVariant ? ', ' + this.selectedVariant.title : '') + '. Guardá los cambios para actualizar el presupuesto.');
    }
    cancelEdit() {
      const original=this.items.find(item=>item.id===this.editingId);
      this.editingId = null;
      if(original){this.quantity.value=original.qty;this.choose(original.giftId,false,original.variantId,original.flavor);this.restoreExtraChoices(this.normalizeExtras(original));}
      this.instructions.value = '';
      this.update();
      this.addButton.focus({preventScroll: true});
      this.announce('Edición cancelada. El presupuesto conserva los datos guardados.');
    }
    removeItem(id) {
      const index = this.items.findIndex(item => item.id === id);
      if (index < 0) return;
      this.items.splice(index, 1);
      if (this.editingId === id) {this.editingId = null; this.instructions.value = '';}
      this.update();
      const next = this.basket.querySelectorAll('[data-edit-line]')[Math.min(index, this.items.length - 1)];
      (next || this.addButton).focus({preventScroll: true});
      this.announce('Regalo quitado. ' + this.state.qty + ' regalos en el presupuesto.');
    }
    integer(value, min, max) {const n = Number(value); return Number.isFinite(n) ? Math.min(max, Math.max(min, Math.floor(n))) : min;}
    parsePrice(value) {
      const clean = String(value ?? '').trim();
      if (!/^\d+(?:[.,]\d{1,2})?$/.test(clean)) return null;
      const [whole, fraction = ''] = clean.replace(',', '.').split('.');
      const cents = Number(whole) * 100 + Number(fraction.padEnd(2, '0'));
      return Number.isSafeInteger(cents) && cents <= 1000000000 ? cents : null;
    }
    readPricing(node) {
      const tiersByQuantity = new Map();
      for (let index = 1; index <= 5; index++) {
        const from = Number(node.getAttribute(`data-tier-${index}-from`));
        if (!Number.isInteger(from) || from <= 0 || from > 100000) continue;
        const price = this.parsePrice(node.getAttribute(`data-tier-${index}-price`));
        tiersByQuantity.set(from, {from, unit: price === 0 ? null : price});
      }
      const price = this.parsePrice(node.dataset.price);
      return {unit: price === 0 ? null : price, tiers: [...tiersByQuantity.values()].sort((a, b) => a.from - b.from), customFrom: this.integer(node.dataset.customFrom, 0, 100000)};
    }
    optionFor(gift, variantId = '') {
      if (!gift) return null;
      if (!gift.variants.length) return variantId ? null : gift;
      const variant = this.variants.get(variantId);
      return variant?.giftId === gift.id ? variant : null;
    }
    priceKey(item) {return JSON.stringify([item.giftId, item.variantId || '']);}
    money(cents) {return cents === null ? 'A confirmar' : this.formatter.format(cents / 100).replace(/\u00a0/g, ' ');}
    priceFor(gift, quantity) {
      let unit = gift.unit, tierFrom = gift.min;
      for (const tier of gift.tiers) {
        if (quantity < tier.from) break;
        unit = tier.unit;
        tierFrom = tier.from;
      }
      return {unit, tierFrom};
    }
    nextPriceHint(option, quantity, gift = option, giftQty = quantity) {
      if (quantity === null || (option.customFrom > 0 && quantity >= option.customFrom) || (gift.customFrom > 0 && giftQty >= gift.customFrom)) return '';
      const next = option.tiers.find(tier => tier.from > quantity && tier.unit !== null && (!option.customFrom || tier.from < option.customFrom) && (!gift.customFrom || giftQty + tier.from - quantity < gift.customFrom));
      const subject = option === gift ? 'regalos' : 'unidades de esta variante';
      const parts = [];
      if (next) parts.push('Desde ' + next.from + ' ' + subject + ': ' + this.money(next.unit) + ' por regalo.');
      if (option.customFrom && option !== gift) parts.push('Desde ' + option.customFrom + ' ' + subject + ': presupuesto personalizado.');
      if (gift.customFrom) parts.push('Desde ' + gift.customFrom + ' regalos de esta categoría, sumando sus variantes: presupuesto personalizado.');
      return parts.join(' ');
    }
    normalizedQuantity(value, gift = this.selectedVariant || this.selected) {
      const raw = Number(value);
      if (!Number.isFinite(raw)) return gift.min;
      return Math.min(gift.max, Math.max(gift.min, gift.min + Math.ceil((raw - gift.min) / gift.step) * gift.step));
    }
    setupGiftCards() {
      for(const gift of this.gifts.values()) {
        gift.cardFlavor=gift.flavors[0]||'';
        this.fillFlavorSelect(gift.card.querySelector('[data-card-flavor]'),gift,gift.cardFlavor);
        gift.card.querySelector('[data-card-flavor-wrap]').hidden=!gift.flavors.length;
        gift.picture=gift.card.querySelector('[data-gift-picture]');
        const select=gift.card.querySelector('[data-card-variant]');
        select.replaceChildren(...gift.variants.map(variant=>{const option=document.createElement('option');option.value=variant.id;option.textContent=variant.title;return option;}));
        select.disabled=gift.variants.length<=1;
        gift.card.querySelector('[data-card-variant-wrap]').hidden=!gift.variants.length;
        gift.cardVariantId=gift.variants[0]?.id||'';
        this.paintGiftCard(gift,gift.variants[0]);
      }
    }
    paintGiftCard(gift,variant) {
      const select=gift.card.querySelector('[data-card-variant]');
      select.value=variant?.id||'';
      const media=gift.card.querySelector('[data-card-media]'),id=variant?.id||'';
      if(media.dataset.mediaVariant===id)return;
      const picture=variant?.picture||gift.picture;
      if(picture)media.replaceChildren(picture.content.cloneNode(true));
      media.dataset.mediaVariant=id;
    }
    paintQuoteImage(gift,option) {
      const src=option.image||gift.image,alt=option.image?option.alt:gift.alt;
      for(const image of this.querySelectorAll('[data-product-image]')) {
        if(src){image.src=src;image.alt=alt;image.hidden=false;}
        else{image.removeAttribute('src');image.alt='';image.hidden=true;}
      }
    }
    parseFlavors(value) {
      return [...new Set(String(value||'').split(/\r?\n/).map(v=>v.trim()).filter(Boolean))];
    }
    fillFlavorSelect(select,gift,value) {
      const placeholder=document.createElement('option');placeholder.value='';placeholder.textContent='Elegí un sabor';placeholder.disabled=true;placeholder.hidden=true;
      select.replaceChildren(placeholder,...gift.flavors.map(title=>{const option=document.createElement('option');option.value=title;option.textContent=title;return option;}));
      select.value=value;select.disabled=!gift.flavors.length||(gift.flavors.length===1&&gift.flavors.includes(value));
    }
    setFlavor(value) {
      const gift=this.selected;
      const requested=value===undefined?gift.cardFlavor:value;
      this.selectedFlavor=gift.flavors.length?(gift.flavors.includes(requested)?requested:''):'';
      gift.cardFlavor=this.selectedFlavor;
      this.fillFlavorSelect(this.flavorSelect,gift,this.selectedFlavor);
      this.fillFlavorSelect(gift.card.querySelector('[data-card-flavor]'),gift,this.selectedFlavor);
      this.querySelector('[data-flavor-field]').hidden=!gift.flavors.length;
      let step=0;for(const field of this.querySelectorAll('[data-form] > .bq__field'))if(!field.hidden)field.querySelector('.bq__step').textContent=String(++step).padStart(2,'0');
    }
    validFlavor(gift,flavor) {return Boolean(gift&&(gift.flavors.length?gift.flavors.includes(flavor):!flavor));}
    notesForServer(item) {
      // Keep the existing server contract: each line carries its own flavor in notes.
      // Never truncate the flavor or overwrite the customer's instructions.
      return (item.flavor?'Sabor: '+item.flavor+'\n':'')+this.cleanNotes(item.notes);
    }
    validFlavorLine(item) {return this.validFlavor(this.gifts.get(item.giftId),item.flavor||'')&&this.notesForServer(item).length<=300;}
    choose(id, scroll, variantId, flavor) {
      const gift = this.gifts.get(id);
      if (!gift) return;
      const preferred = variantId === undefined ? (this.selected?.id === id ? this.selectedVariant?.id : gift.cardVariantId) : variantId;
      this.selected = gift;
      this.setFlavor(flavor);
      this.select.value = id;
      const choices = gift.variants.length ? gift.variants : [{id: '', title: this.dataset.singleVariantLabel}];
      this.variantSelect.replaceChildren(...choices.map(variant => {
        const option = document.createElement('option'); option.value = variant.id; option.textContent = variant.title; return option;
      }));
      this.variantSelect.disabled = choices.length === 1;
      this.querySelector('[data-variant-help]').hidden = choices.length !== 1;
      this.setVariant(choices.some(variant => variant.id === preferred) ? preferred : choices[0].id);
      for (const entry of this.gifts.values()) {
        entry.card.dataset.selected = String(entry.id === id);
        entry.card.querySelector('[data-choose]').setAttribute('aria-pressed', String(entry.id === id));
      }
      this.update();
      if (scroll) {
        this.querySelector('[data-quote-heading]').focus({preventScroll: true});
        this.querySelector('[data-quote-target]').scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
      }
    }
    setVariant(id) {
      const option = this.optionFor(this.selected, id);
      if (!option) return false;
      this.selectedVariant = option === this.selected ? null : option;
      this.variantSelect.value = this.selectedVariant?.id || '';
      this.quantity.value = this.normalizedQuantity(this.quantity.value, option);
      this.quantity.min = option.min;
      this.quantity.max = option.max;
      this.quantity.step = option.step;
      this.selected.cardVariantId=this.selectedVariant?.id||'';
      this.paintGiftCard(this.selected,this.selectedVariant);
      this.paintQuoteImage(this.selected,option);
      return true;
    }
    chooseVariant(id) {
      if (!this.setVariant(id)) return;
      this.update();
      this.announce('Variante seleccionada: ' + (this.selectedVariant?.title || this.dataset.singleVariantLabel) + '. Cantidad: ' + this.quantity.value + '.');
    }
    changeQuantity(direction) {
      const g = this.selectedVariant || this.selected;
      const raw = Number(this.quantity.value);
      const valid = this.quantity.value !== '' && Number.isInteger(raw) && raw >= g.min && raw <= g.max && (raw - g.min) % g.step === 0;
      let next;
      if (valid) next = raw + direction * g.step;
      else if (direction > 0) next = this.normalizedQuantity(raw);
      else next = g.min + Math.floor((raw - g.min) / g.step) * g.step;
      this.quantity.value = this.normalizedQuantity(next);
      this.update();
    }
    dateKey(date) {return date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');}
    displayDate(value) {if (!value) return 'A coordinar'; const [y,m,d] = value.split('-'); return d + '/' + m + '/' + y;}
    calculate(items) {
      const quantities = new Map(), priceQuantities = new Map();
      for (const item of items) {
        quantities.set(item.giftId, (quantities.get(item.giftId) || 0) + item.qty);
        const key = this.priceKey(item);
        priceQuantities.set(key, (priceQuantities.get(key) || 0) + item.qty);
      }
      const customGifts = [...quantities].filter(([id, qty]) => this.gifts.get(id).customFrom > 0 && qty >= this.gifts.get(id).customFrom).map(([id, qty]) => ({title: this.gifts.get(id).title, from: this.gifts.get(id).customFrom, qty}));
      const checkedVariants = new Set();
      for (const item of items) {
        const variant = this.variants.get(item.variantId);
        if (!variant || checkedVariants.has(variant.id)) continue;
        checkedVariants.add(variant.id);
        const qty = priceQuantities.get(this.priceKey(item));
        if (variant.customFrom > 0 && qty >= variant.customFrom) customGifts.push({title: this.gifts.get(item.giftId).title + ' · ' + variant.title, from: variant.customFrom, qty});
      }
      const customRequired = customGifts.length > 0;
      const charges = new Map();
      const lines = items.map(item => {
        const gift = this.gifts.get(item.giftId);
        const selectedExtras=this.normalizeExtras(item).map(row=>({...this.extraOptions.get(row.id),count:row.count}));
        const giftQty = quantities.get(item.giftId), priceQty = priceQuantities.get(this.priceKey(item));
        const option = this.optionFor(gift, item.variantId);
        const price = this.priceFor(option, priceQty);
        const unit = customRequired ? null : price.unit;
        const extraUnit = customRequired || selectedExtras.some(e=>e.unit===null) ? null : selectedExtras.reduce((n,e)=>n+e.unit*e.count,0);
        const products = unit === null ? null : item.qty * unit;
        const extras = extraUnit === null || !Number.isSafeInteger(item.qty*extraUnit) ? null : item.qty * extraUnit;
        selectedExtras.forEach(e=>charges.set(e.id,{title:e.title,amount:customRequired?null:e.fixed}));
        return {...item, gift: gift.title, variant: option === gift ? '' : option.title, extra: selectedExtras.map(e=>e.title+' × '+e.count+' por regalo').join('; ')||'Sin personalización', extraDetails:selectedExtras.map(e=>({id:e.id,title:e.title,count:e.count,unit:e.unit,total:e.unit===null?null:e.unit*e.count*item.qty})), image: option.image || gift.image, alt: option.image ? option.alt : gift.alt, giftQty, priceQty, tierFrom: price.tierFrom, unit, extraUnit, products, extras, subtotal: products === null || extras === null ? null : products + extras};
      });
      const sum = values => values.some(value => value === null) ? null : Number.isSafeInteger(values.reduce((a,b)=>a+b,0))?values.reduce((a,b)=>a+b,0):null;
      const fixedCharges = [...charges.values()];
      const products = customRequired ? null : sum(lines.map(row => row.products));
      const extras = customRequired ? null : sum(lines.map(row => row.extras));
      const fixed = customRequired ? null : sum(fixedCharges.map(row => row.amount));
      const subtotal = sum([products, extras, fixed]);
      const option = this.delivery.selectedOptions[0];
      const delivery = customRequired ? null : this.parsePrice(option?.dataset.price);
      const total = sum([subtotal, delivery]);
      return {lines, fixedCharges, customGifts, customRequired, products, extras, fixed, subtotal, delivery, total, qty: items.reduce((n,row) => n + row.qty, 0), urgent:this.urgent.checked, date: this.date.value, deliveryName: option?.textContent.trim() || 'A coordinar'};
    }
    update() {
      if (!this.selected) return;
      const gift = this.selected, option = this.selectedVariant || gift, variantId = this.selectedVariant?.id || '', raw = Number(this.quantity.value);
      const quantityValid = this.quantity.value !== '' && !this.quantity.validity.badInput && this.validQuantity(raw, option);
      const qty = quantityValid ? raw : null;
      let removed=false,availableExtras=0;
      for(const e of this.extraOptions.values()) {
        const allowed=this.extraAllowed(e,gift),check=e.label.querySelector('input[type=checkbox]');
        if(!allowed&&check.checked){check.checked=false;removed=true;}
        e.label.hidden=!allowed;check.disabled=!allowed;
        if(allowed)availableExtras++;
        e.label.querySelector('[data-extra-count-wrap]').hidden=!check.checked||e.max===1;
      }
      this.querySelector('[data-extras-note]').textContent=removed?'Se quitaron opciones no disponibles para este regalo o plazo. Revisá tu selección.':availableExtras?'Sin marcar opciones, se cotiza sin personalización.':'Este regalo no tiene personalizaciones disponibles para la modalidad elegida.';
      const selectedExtras=this.chosenExtras();
      const extrasValid=this.validExtras(selectedExtras,gift);
      const extra={unit:selectedExtras.some(e=>this.extraOptions.get(e.id).unit===null)?null:selectedExtras.reduce((n,e)=>n+this.extraOptions.get(e.id).unit*e.count,0),fixed:0};
      const rest = this.items.filter(item => item.id !== this.editingId);
      const giftQty = rest.filter(item => item.giftId === gift.id).reduce((n,item) => n + item.qty, 0) + (qty || 0);
      const priceQty = rest.filter(item => item.giftId === gift.id && (item.variantId || '') === variantId).reduce((n,item) => n + item.qty, 0) + (qty || 0);
      const withinLimit = giftQty <= 100000 && rest.length < 50;
      const flavor=this.selectedFlavor||'',flavorValid=this.validFlavor(gift,flavor);
      const notesLimit=Math.max(0,300-(flavor?'Sabor: '+flavor+'\n':'').length);
      const notesValid=this.notesForServer({flavor,notes:this.instructions.value}).length<=300;
      this.instructions.maxLength=notesLimit;
      this.querySelector('[data-notes-limit]').textContent='Indicaciones: hasta '+notesLimit+' caracteres.';
      this.instructions.setAttribute('aria-invalid',String(!notesValid));
      const flavorError=this.querySelector('[data-flavor-error]');flavorError.hidden=flavorValid;flavorError.textContent=flavorValid?'':'Elegí un sabor para esta selección.';
      this.flavorSelect.setAttribute('aria-invalid',String(!flavorValid));
      this.draft = {qty, extras:selectedExtras, valid: quantityValid && withinLimit && extrasValid && flavorValid && notesValid};
      const candidate = this.draft.valid ? this.calculate([...rest, {id: 'draft', giftId: gift.id, variantId, flavor, extras:selectedExtras, qty, notes: ''}]) : null;
      const draftLine = candidate?.lines.at(-1);
      const normalDate=this.normalDate();
      this.date.min=this.urgent.checked?this.todayKey():normalDate;
      const dateValid=!this.date.validity.badInput&&(!this.date.value||this.date.value>=this.date.min);
      this.querySelector('[data-lead-note]').textContent='Plazo mínimo normal: '+this.integer(this.dataset.leadDays,0,3650)+' días '+(this.dataset.leadMode==='business'?'hábiles (según calendario configurado)':'corridos')+'. Primera fecha estimada: '+this.displayDate(normalDate)+'.';
      this.querySelector('[data-urgent-note]').hidden=!this.urgent.checked;
      const quantityError = this.querySelector('[data-quantity-error]');
      quantityError.hidden = quantityValid;
      quantityError.textContent = quantityValid ? '' : 'Ingresá una cantidad entre ' + option.min + ' y ' + option.max + ', en incrementos de ' + option.step + ' a partir de ' + option.min + '.';
      this.quantity.setAttribute('aria-invalid', String(!quantityValid));
      const dateError = this.querySelector('[data-date-error]');
      dateError.hidden = dateValid;
      dateError.textContent = dateValid ? '' : 'Elegí una fecha a partir del ' + this.displayDate(this.date.min) + '.';
      this.date.setAttribute('aria-invalid', String(!dateValid));
      const addError = this.querySelector('[data-add-error]');
      addError.hidden = withinLimit && notesValid;
      addError.textContent = !notesValid ? 'Acortá las indicaciones a '+notesLimit+' caracteres para guardar el sabor completo junto con tu pedido.' : withinLimit ? '' : giftQty > 100000 ? 'El presupuesto admite hasta 100.000 unidades de cada regalo.' : 'El presupuesto admite hasta 50 líneas. Editá una existente o solicitá una propuesta a medida.';
      this.querySelector('[data-quantity-help]').textContent = 'Mínimo por línea: ' + option.min + (option.step > 1 ? '. De ' + option.step + ' en ' + option.step : '') + '.';
      const hint = this.querySelector('[data-tier-hint]');
      hint.textContent = quantityValid ? (priceQty > qty ? 'Con esta selección sumarías ' + priceQty + ' unidades de ' + option.title + '. ' : '') + this.nextPriceHint(option, priceQty, gift, giftQty) : '';
      hint.hidden = !hint.textContent;
      this.querySelector('[data-minus]').disabled = quantityValid && raw <= option.min;
      this.querySelector('[data-plus]').disabled = quantityValid && raw >= option.max;
      for (const option of this.extraOptions.values()) {
        const label = option.label.querySelector('[data-extra-price]');
        label.hidden = Boolean(candidate?.customRequired);
        if (option.unit === null || option.fixed === null) label.textContent = 'A confirmar';
        else if (option.unit === 0 && option.fixed === 0) label.textContent = 'Sin adicional';
        else label.textContent = (option.unit ? this.money(option.unit) + ' por unidad del adicional' : '') + (option.unit && option.fixed ? ' + ' : '') + (option.fixed ? this.money(option.fixed) + ' por pedido' : '');
      }
      const draftCost = this.querySelector('[data-draft-cost]');
      draftCost.textContent = !this.draft.valid ? 'Revisá el sabor, la cantidad y las indicaciones antes de agregar.' : candidate.customRequired ? 'Con esta selección, el pedido requiere presupuesto personalizado.' : qty + ' × ' + this.money(draftLine.unit) + ' por regalo. Personalización: ' + this.money(extra.unit) + ' por regalo.' + (extra.fixed === 0 ? '' : ' Cargo fijo de esta opción: ' + this.money(extra.fixed) + ', una vez por pedido.');
      this.addButton.disabled = !this.draft.valid;
      this.addButton.textContent = this.editingId ? this.dataset.updateLabel : this.dataset.addLabel;
      this.querySelector('[data-edit-note]').hidden = !this.editingId;
      this.querySelector('[data-cancel-edit]').hidden = !this.editingId;
      this.querySelector('[data-pending-edit]').hidden = !this.editingId;
      const s = this.calculate(this.items);
      const flavorsValid=this.items.every(row=>this.validFlavorLine(row));
      this.querySelector('[data-flavor-review]').hidden=flavorsValid;
      s.valid = this.items.length > 0 && dateValid && flavorsValid && this.items.every(row=>this.validExtras(this.normalizeExtras(row),this.gifts.get(row.giftId)));
      if(!s.valid&&this.items.length&&dateValid&&flavorsValid)this.querySelector('[data-extras-note]').textContent='El presupuesto contiene personalizaciones que no están disponibles con la urgencia seleccionada. Editá esas líneas antes de continuar.';
      this.state = s;
      this.renderBasket(s);
      const hasItems = this.items.length > 0;
      this.querySelector('[data-basket-empty]').hidden = hasItems;
      this.querySelector('[data-basket-count]').textContent = hasItems ? s.qty + (s.qty === 1 ? ' regalo' : ' regalos') + ' · ' + this.items.length + (this.items.length === 1 ? ' selección' : ' selecciones') : '';
      for (const element of this.querySelectorAll('[data-amount]')) element.textContent = element.dataset.amount === 'delivery' && s.delivery === null ? 'A cotizar' : this.money(s[element.dataset.amount]);
      this.querySelector('[data-total-row]').hidden = s.total === null;
      this.querySelector('[data-totals]').hidden = !hasItems || s.customRequired;
      this.querySelector('[data-fixed-row]').hidden = s.fixed === 0;
      const fixedNote = this.querySelector('[data-fixed-note]');
      fixedNote.hidden = !hasItems || s.customRequired || s.fixed === 0;
      fixedNote.textContent = 'Cargo fijo, una vez por opción: ' + s.fixedCharges.filter(row => row.amount !== 0).map(row => row.title + ' (' + this.money(row.amount) + ')').join('; ') + '.';
      this.querySelector('[data-custom-quote]').hidden = !s.customRequired;
      this.querySelector('[data-custom-copy]').textContent = s.customGifts.map(entry => entry.title + ': ' + (this.dataset.customMessage || 'Desde {cantidad} regalos preparamos un presupuesto personalizado.').replaceAll('{cantidad}', String(entry.from))).join(' ') + (s.customRequired ? ' La solicitud incluirá todos los regalos del presupuesto.' : '');
      this.dataset.customRequired = String(s.customRequired);
      this.requestLink.textContent = s.customRequired ? this.dataset.customLabel : this.confirmLabel;
      const preview = this.querySelector('[data-editor-contact]');
      if (preview) preview.textContent = this.requestLink.textContent;
      this.querySelector('[data-date-note]').textContent = this.date.value ? (this.urgent.checked?'URGENTE · ':'')+'Fecha deseada: ' + this.displayDate(this.date.value) + '. Sujeta a confirmación.' : 'Fecha sujeta a confirmación.';
      this.downloadButton.disabled = !this.canExport() || s.customRequired || this.busy;
      this.downloadButton.hidden = s.customRequired;
      this.requestLink.setAttribute('aria-disabled', String(!this.canExport()));
      if (this.contactReady && this.canExport()) {
        const message = this.summaryText(s);
        this.requestLink.href = this.dataset.contactMode === 'email' ? 'mailto:' + encodeURIComponent(this.email) + '?subject=' + encodeURIComponent('Consulta de presupuesto - ' + this.dataset.brand) + '&body=' + encodeURIComponent(message) : 'https://wa.me/' + this.phone + '?text=' + encodeURIComponent(message);
        this.requestLink.removeAttribute('tabindex');
      } else {this.requestLink.removeAttribute('href'); this.requestLink.tabIndex = -1;}
      this.querySelector('[data-action-error]').hidden = true;
      const pay=this.querySelector('[data-pay-deposit]');
      pay.hidden=!this.endpoint()&&this.dataset.editor!=='true';
      pay.disabled=!this.endpoint()||!this.checkoutReady();
      pay.textContent='Pagar seña del 50%'+(s.total!==null&&hasItems&&!s.customRequired?' · '+this.money(Math.ceil(s.total/2)):'');
      this.querySelector('[data-deposit-note]').textContent=s.total!==null&&hasItems&&!s.customRequired?'Seña estimada: '+this.money(Math.ceil(s.total/2))+'. Saldo estimado: '+this.money(s.total-Math.ceil(s.total/2))+'. Pedido y fecha sujetos a confirmación.':'';
      this.syncStarter();
      this.saveItems();
    }
    renderBasket(s) {
      const signature = JSON.stringify([s.lines, s.customRequired, this.editingId]);
      if (signature === this.renderedBasket) return;
      this.renderedBasket = signature;
      const node = (tag, className, text) => {const el = document.createElement(tag); el.className = className; if (text !== undefined) el.textContent = text; return el;};
      const fragment = document.createDocumentFragment();
      for (const row of s.lines) {
        const li = node('li', 'bq__basket-line');
        li.dataset.lineId = row.id;
        li.dataset.editing = String(this.editingId === row.id);
        const top = node('div', 'bq__line-top'), copy = node('div', 'bq__line-copy');
        if (row.image) {const img = node('img', 'bq__thumb'); img.src = row.image; img.alt = ''; img.width = 52; img.height = 52; img.loading = 'lazy'; top.append(img);}
        copy.append(node('strong', 'bq__summary-name', row.gift), node('span', 'bq__summary-detail', row.qty + (row.qty === 1 ? ' unidad' : ' unidades') + ' · ' + row.extra));
        if (row.variant) copy.append(node('span', 'bq__summary-detail', 'Variante: ' + row.variant));
        if(row.flavor)copy.append(node('span','bq__summary-detail','Sabor: '+row.flavor));
        if(!this.validFlavorLine(row))copy.append(node('span','bq__error','Revisá el sabor o las indicaciones con Editar.'));
        for(const extra of row.extraDetails)copy.append(node('span','bq__summary-detail',extra.title+': '+extra.count+' por regalo × '+this.money(extra.unit)));
        if (row.notes) copy.append(node('span', 'bq__summary-detail', row.notes));
        if (!s.customRequired) {
          copy.append(node('p', 'bq__line-cost', 'Regalos: ' + row.qty + ' × ' + this.money(row.unit) + ' = ' + this.money(row.products)));
          if (row.extraUnit !== 0) copy.append(node('span', 'bq__summary-detail', 'Personalización: ' + row.qty + ' × ' + this.money(row.extraUnit) + ' = ' + this.money(row.extras)));
          if (row.priceQty > row.qty) copy.append(node('span', 'bq__summary-detail', 'Precio según ' + row.priceQty + ' unidades de ' + (row.variant ? 'esta variante' : 'este regalo') + ' en el pedido.'));
        }
        const actions = node('div', 'bq__line-actions');
        const edit = node('button', 'bq__text-button', 'Editar'), remove = node('button', 'bq__text-button', 'Quitar');
        edit.type = remove.type = 'button';
        edit.dataset.editLine = remove.dataset.removeLine = row.id;
        edit.setAttribute('aria-label', 'Editar ' + row.gift + (row.variant ? ', ' + row.variant : '') + (row.flavor?', sabor '+row.flavor:'') + ', ' + row.qty + ' unidades');
        remove.setAttribute('aria-label', 'Quitar ' + row.gift + (row.variant ? ', ' + row.variant : '') + (row.flavor?', sabor '+row.flavor:'') + ', ' + row.qty + ' unidades');
        actions.append(edit, remove); copy.append(actions); top.append(copy); li.append(top); fragment.append(li);
      }
      this.basket.replaceChildren(fragment);
    }
    summaryText(s) {
      const text = [s.customRequired ? 'Hola, quisiera solicitar un presupuesto personalizado a ' + this.dataset.brand + ':' : 'Hola, quisiera confirmar este presupuesto de ' + this.dataset.brand + ':', ''];
      s.lines.forEach((row, i) => {
        text.push((i + 1) + '. ' + row.gift);
        if (row.variant) text.push('Variante: ' + row.variant);
        if(row.flavor)text.push('Sabor: '+row.flavor);
        text.push('Cantidad: ' + row.qty, 'Personalización: ' + row.extra);
        if (row.notes) text.push('Indicaciones: ' + row.notes);
        if (!s.customRequired) text.push('Precio por regalo: ' + this.money(row.unit), 'Adicional por regalo: ' + this.money(row.extraUnit), 'Importe de la línea (sin cargos fijos): ' + this.money(row.subtotal));
        text.push('');
      });
      text.push('Cantidad total: ' + s.qty, 'Fecha deseada: ' + this.displayDate(s.date), 'Entrega: ' + s.deliveryName, '');
      if (s.customRequired) text.push('Este pedido requiere una propuesta a medida. Precios y condiciones a confirmar.');
      else {
        text.push('Productos: ' + this.money(s.products), 'Personalización por unidad: ' + this.money(s.extras));
        for (const row of s.fixedCharges) if (row.amount !== 0) text.push('Cargo fijo · ' + row.title + ': ' + this.money(row.amount));
        text.push('Subtotal: ' + this.money(s.subtotal), 'Cargo de entrega: ' + (s.delivery === null ? 'A cotizar' : this.money(s.delivery)), 'Total estimado: ' + this.money(s.total), '', this.dataset.quoteNote, this.dataset.taxNote || '');
      }
      text.push('Modalidad: '+(s.urgent?'URGENTE — requiere confirmación expresa':'Normal'),'',...Object.entries(this.customerData()).filter(([,v])=>v).map(([k,v])=>this.customerLabel(k)+': '+v),'',this.termsText());
      return text.join('\n');
    }
    async download() {
      this.update();
      if (!this.canExport() || this.state.customRequired) return;
      try {
        if(this.endpoint()){for(const field of this.querySelectorAll('[data-customer-field]'))if(!field.reportValidity())return;this.setBusy(true);await this.remoteDownload();return;}
        const bytes = this.makePdf({...this.state});
        const url = URL.createObjectURL(new Blob([bytes], {type: 'application/pdf'}));
        const link = document.createElement('a');
        link.href = url;
        link.download = 'presupuesto-atelier-' + this.dateKey(new Date()) + '.pdf';
        link.style.display = 'none';
        document.body.append(link);
        link.click();
        link.remove();
        setTimeout(() => URL.revokeObjectURL(url), 60000);
        this.querySelector('[data-status]').textContent = 'Presupuesto generado. Revisá las descargas de tu navegador.';
      } catch (_) {
        const error = this.querySelector('[data-action-error]');
        error.textContent = 'No pudimos generar o registrar el PDF. Revisá la conexión y los datos. Si cambió el catálogo, recargá la página; también podés solicitar confirmación por nuestro canal de contacto.';
        error.hidden = false;
      } finally {if(this.busy)this.setBusy(false);}
    }
    makePdf(s) {
      if (s.customRequired) throw new Error('Este pedido requiere un presupuesto personalizado.');
      if (!s.valid || !s.lines.length) throw new Error('Agregá regalos y revisá los datos del pedido.');
      // PDF 1.4 con texto seleccionable, fuentes estándar y codificación WinAnsi.
      // No hay peticiones externas, imágenes remotas ni datos ejecutables en el PDF.
      const cp1252 = {8364:128,8218:130,402:131,8222:132,8230:133,8224:134,8225:135,710:136,8240:137,352:138,8249:139,338:140,381:142,8216:145,8217:146,8220:147,8221:148,8226:149,8211:150,8212:151,732:152,8482:153,353:154,8250:155,339:156,382:158,376:159};
      const clean = value => String(value ?? '').normalize('NFC').replace(/[\r\n\t]+/g, ' ').replace(/[\x00-\x1f\x7f]/g, '').trim();
      const hex = value => [...clean(value)].map(char => {const code = char.codePointAt(0); const byte = code < 256 ? code : cp1252[code] ?? 63; return byte.toString(16).padStart(2, '0');}).join('');
      const style = getComputedStyle(this);
      const color = (name, fallback) => {
        const match = style.getPropertyValue(name).trim().match(/^#([0-9a-f]{6})$/i);
        const value = match ? match[1] : fallback;
        return [0,2,4].map(i => (parseInt(value.slice(i, i + 2), 16) / 255).toFixed(3)).join(' ');
      };
      const ink = color('--bq-text', '303030'), brand = color('--bq-heading', '45132c'), accent = color('--bq-button', 'e02c50');
      const muted = color('--bq-muted', '6b6265'), paper = '1 1 1', rule = color('--bq-border', 'e6dcd9');
      const pages = [];
      let commands, y;
      const text = (value, x, top, size = 11, bold = false, fill = ink) => commands.push(`${fill} rg BT /${bold ? 'F2' : 'F1'} ${size} Tf 1 0 0 1 ${x} ${842 - top} Tm <${hex(value)}> Tj ET`);
      const rect = (x, top, w, h, fill) => commands.push(`${fill} rg ${x} ${842 - top - h} ${w} ${h} re f`);
      const line = top => commands.push(`${rule} RG 0.6 w 42 ${842 - top} m 553 ${842 - top} l S`);
      const measure = document.createElement('canvas').getContext('2d');
      const wrap = (value, width, size = 11, bold = false) => {
        measure.font = `${bold ? 'bold ' : ''}${size}px Arial`;
        const result = []; let current = '';
        for (const word of clean(value).split(/\s+/)) {
          if (measure.measureText((current ? current + ' ' : '') + word).width <= width) {current += (current ? ' ' : '') + word; continue;}
          if (current) {result.push(current); current = '';}
          let part = '';
          for (const char of word) {if (measure.measureText(part + char).width > width && part) {result.push(part); part = '';} part += char;}
          current = part;
        }
        if (current) result.push(current);
        return result.length ? result : [''];
      };
      const newPage = () => {
        commands = []; pages.push(commands);
        rect(0, 0, 595, 104, brand);
        const brandLines = wrap(this.dataset.brand || 'Atelier de Chocolates', 505, 17, true);
        text(brandLines[0], 42, 38, 17, true, paper);
        text(s.subtotal === null ? 'Solicitud de presupuesto' : 'Presupuesto estimativo', 42, 66, 15, true, paper);
        text('REGALOS EMPRESARIALES', 42, 86, 8, false, paper);
        y = 128;
      };
      const ensure = height => {if (y + height > 754) newPage();};
      const paragraph = (value, size = 11, fill = ink, bold = false) => {
        for (const row of wrap(value, 505, size, bold)) {ensure(size * 1.5); text(row, 42, y, size, bold, fill); y += size * 1.5;}
      };
      const detail = (label, value) => {ensure(46); text(label.toUpperCase(), 42, y, 8, true, muted); y += 16; paragraph(value, 12); y += 10;};
      const amount = (label, value, bold = false, large = false) => {
        const size = large ? 14 : 11;
        const lines = wrap(value, 200, size, bold);
        ensure(Math.max(23, lines.length * 18));
        text(label, 42, y, size, bold, large ? brand : ink);
        lines.forEach((row, index) => text(row, 353, y + index * 18, size, bold, large ? brand : ink));
        y += Math.max(23, lines.length * 18);
      };
      newPage();
      paragraph('Generado el ' + new Intl.DateTimeFormat('es-UY', {dateStyle:'short', timeStyle:'short'}).format(new Date()), 9, muted);
      y += 8;
      paragraph(s.lines.length + (s.lines.length === 1 ? ' selección' : ' selecciones') + ' · ' + s.qty + ' regalos', 11, brand, true);
      y += 8;
      s.lines.forEach((row, index) => {
        const fields = [
          [(index + 1) + '. ' + row.gift, 13, brand, true],
          ...(row.variant ? [['Variante: ' + row.variant, 11, ink, true]] : []),
          ...(row.flavor ? [['Sabor: ' + row.flavor, 11, ink, true]] : []),
          ['Cantidad: ' + row.qty + ' · Precio por regalo: ' + this.money(row.unit), 11, ink, false],
          ['Personalización: ' + row.extra + ' · ' + this.money(row.extraUnit) + ' por unidad.', 10, muted, false]
        ];
        for(const extra of row.extraDetails)fields.push([extra.title+': '+extra.count+' por regalo × '+row.qty+' regalos × '+this.money(extra.unit)+' = '+this.money(extra.total),10,muted,false]);
        if (row.notes) fields.push(['Indicaciones: ' + row.notes, 10, ink, false]);
        if (row.priceQty > row.qty) fields.push(['Precio calculado sobre ' + row.priceQty + ' unidades de ' + (row.variant ? 'esta variante' : 'este regalo') + ' en el pedido.', 9, muted, false]);
        fields.push(['Productos: ' + this.money(row.products) + ' · Personalización: ' + this.money(row.extras), 10, ink, false]);
        fields.push(['Importe de la línea, sin cargos fijos: ' + this.money(row.subtotal), 11, ink, true]);
        const height = fields.reduce((total, [value, size, fill, bold]) => total + wrap(value, 505, size, bold).length * size * 1.5, 0);
        ensure(Math.min(height + 23, 620));
        line(y); y += 15;
        fields.forEach(field => paragraph(...field));
        y += 8;
      });
      ensure(60);
      line(y); y += 20;
      paragraph('Modalidad: '+(s.urgent?'URGENTE — sujeta a capacidad y confirmación':'Normal'),11,brand,true);
      for(const [key,value] of Object.entries(this.customerData()))if(value)paragraph(this.customerLabel(key)+': '+value,10);
      paragraph('Fecha deseada: ' + this.displayDate(s.date) + ' · Sujeta a confirmación.', 10);
      paragraph('Entrega del pedido: ' + s.deliveryName, 10);
      y += 10;
      if (s.fixedCharges.some(row => row.amount !== 0)) {
        paragraph('Cargos fijos de personalización · una vez por opción', 10, muted, true);
        for (const row of s.fixedCharges) if (row.amount !== 0) paragraph(row.title + ': ' + this.money(row.amount), 10, muted);
        y += 8;
      }
      ensure(165); line(y); y += 22;
      amount('Productos', this.money(s.products));
      amount('Personalización por unidad', this.money(s.extras));
      if (s.fixed !== 0) amount('Cargos fijos de personalización', this.money(s.fixed));
      amount('Subtotal', this.money(s.subtotal), true);
      amount('Entrega', s.delivery === null ? 'A cotizar' : this.money(s.delivery));
      amount('Total estimado', s.total === null ? 'A confirmar' : this.money(s.total), true, true);
      y += 8;
      paragraph('COTIZACIÓN ESTIMATIVA — NO ES CONFIRMACIÓN DE PRODUCCIÓN',11,brand,true);
      if(s.total!==null){amount('Seña estimada (50%)',this.money(Math.ceil(s.total/2)));amount('Saldo estimado',this.money(s.total-Math.ceil(s.total/2)));}
      for(const part of this.termsText().split(/\n\s*\n/)){y+=8;paragraph(part,9,muted);}
      paragraph(this.dataset.quoteNote, 10, muted);
      if (this.dataset.taxNote) {y += 5; paragraph(this.dataset.taxNote, 10, muted);}
      for (let i = 0; i < pages.length; i++) {
        commands = pages[i];
        rect(42, 786, 42, 3, accent);
        text((this.dataset.site || '').slice(0, 90), 42, 809, 8, false, muted);
        text((i + 1) + ' / ' + pages.length, 519, 809, 8, false, muted);
      }
      const objects = [null, '<< /Type /Catalog /Pages 2 0 R >>', '', '<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica /Encoding /WinAnsiEncoding >>', '<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica-Bold /Encoding /WinAnsiEncoding >>'];
      const pageIds = [];
      for (const pageCommands of pages) {
        const pageId = objects.length, streamId = pageId + 1;
        pageIds.push(pageId);
        objects.push(`<< /Type /Page /Parent 2 0 R /MediaBox [0 0 595 842] /Resources << /Font << /F1 3 0 R /F2 4 0 R >> >> /Contents ${streamId} 0 R >>`);
        const stream = pageCommands.join('\n');
        objects.push(`<< /Length ${stream.length} >>\nstream\n${stream}\nendstream`);
      }
      objects[2] = `<< /Type /Pages /Kids [${pageIds.map(id => id + ' 0 R').join(' ')}] /Count ${pageIds.length} >>`;
      let pdf = '%PDF-1.4\n';
      const offsets = [0];
      for (let i = 1; i < objects.length; i++) {offsets[i] = pdf.length; pdf += i + ' 0 obj\n' + objects[i] + '\nendobj\n';}
      const xref = pdf.length;
      pdf += 'xref\n0 ' + objects.length + '\n0000000000 65535 f \n';
      for (let i = 1; i < objects.length; i++) pdf += String(offsets[i]).padStart(10, '0') + ' 00000 n \n';
      pdf += 'trailer\n<< /Size ' + objects.length + ' /Root 1 0 R >>\nstartxref\n' + xref + '\n%%EOF';
      return new TextEncoder().encode(pdf);
    }
  }
  customElements.define('atelier-business-quote', AtelierBusinessQuote);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-inicio-selector-productos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('atelier-product-selections')) {
    customElements.define('atelier-product-selections', class extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => this.init());
      }
      init() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-panel]'));
        const list = this.querySelector('[data-tabs]');
        if (!list || !this.tabs.length) return;
        list.setAttribute('role', 'tablist');
        this.tabs.forEach((tab, index) => {
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', this.panels[index].id);
          this.panels[index].setAttribute('role', 'tabpanel');
          tab.addEventListener('click', event => { event.preventDefault(); this.select(index); }, options);
          tab.addEventListener('keydown', event => {
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
            if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.tabs.length - 1;
            if (event.key === ' ') { event.preventDefault(); this.select(index); return; }
            if (next !== undefined) { event.preventDefault(); this.select(next); this.tabs[next].focus({ preventScroll: true }); }
          }, options);
        });
        this.panels.forEach(panel => {
          const track = panel.querySelector('.aps__track');
          track.addEventListener('scroll', () => this.updateControls(panel), { ...options, passive: true });
          panel.querySelectorAll('[data-direction]').forEach(button => {
            button.addEventListener('click', () => {
              const card = track.firstElementChild;
              if (!card) return;
              const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0);
              track.scrollBy({ left: step * Number(button.dataset.direction), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
            }, options);
          });
        });
        document.addEventListener('shopify:block:select', event => {
          const index = this.tabs.findIndex(tab => tab.dataset.tab === event.detail.blockId);
          if (index >= 0) this.select(index);
        }, options);
        this.setAttribute('data-ready', '');
        this.select(0);
        this.observer = new ResizeObserver(entries => {
          const width = entries[0].contentRect.width;
          if (width !== this.lastWidth) { this.lastWidth = width; this.layout(); }
        });
        this.observer.observe(this);
        document.fonts.ready.then(() => { if (this.isConnected) this.layout(); });
      }
      select(index) {
        this.index = index;
        this.tabs.forEach((tab, i) => {
          const selected = i === index;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          this.panels[i].hidden = !selected;
        });
        this.panels[index].querySelector('.aps__track').scrollLeft = 0;
        this.layout();
      }
      layout() {
        const panel = this.panels && this.panels[this.index];
        if (!panel) return;
        for (const [selector, property] of [['.aps__product-title', '--aps-product-title-height'], ['.aps__price', '--aps-price-height']]) {
          panel.style.setProperty(property, '0px');
          const nodes = Array.from(panel.querySelectorAll(selector));
          const height = Math.max(0, ...nodes.map(node => node.getBoundingClientRect().height));
          panel.style.setProperty(property, Math.ceil(height) + 'px');
        }
        this.updateControls(panel);
      }
      updateControls(panel) {
        const track = panel.querySelector('.aps__track');
        const controls = panel.querySelector('.aps__controls');
        const overflow = track.scrollWidth > track.clientWidth + 2;
        controls.hidden = !overflow;
        controls.querySelector('[data-direction="-1"]').disabled = track.scrollLeft <= 2;
        controls.querySelector('[data-direction="1"]').disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-marroc-cuatro-opciones"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('atelier-marroc-options')) {
    customElements.define('atelier-marroc-options', class extends HTMLElement {
      connectedCallback() {
        if (this._am4Controller) this._am4Controller.abort();
        this._am4Controller = new AbortController();
        const options = { signal: this._am4Controller.signal };
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-am4-filter]');
          if (!button || !this.contains(button)) return;
          this.filter(button.dataset.am4Filter);
        }, options);
        document.addEventListener('shopify:block:select', (event) => {
          if (!event.detail) return;
          const selected = Array.from(this.querySelectorAll('[data-am4-card]')).find(card => card.dataset.blockId === event.detail.blockId);
          if (selected && selected.hidden) this.filter('all');
        }, options);
        const toolbar = this.querySelector('[data-am4-toolbar]');
        if (toolbar) toolbar.hidden = false;
        this.filter('all');
      }
      disconnectedCallback() {
        if (this._am4Controller) this._am4Controller.abort();
      }
      filter(group) {
        let count = 0;
        this.querySelectorAll('[data-am4-card]').forEach(card => {
          card.hidden = group !== 'all' && card.dataset.group !== group;
          if (!card.hidden) count += 1;
        });
        this.querySelectorAll('[data-am4-filter]').forEach(button => {
          button.setAttribute('aria-pressed', String(button.dataset.am4Filter === group));
        });
        const status = this.querySelector('[data-am4-count]');
        if (status) status.textContent = `${count} ${count === 1 ? this.dataset.singular : this.dataset.plural}`;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-presentacion-preguntas"] && !Shopify.designMode) return;
  try {
    
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:block:select', function (event) {
      const item = event.target.closest('[data-atelier-faq]');
      if (item) item.open = true;
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-rama-detalles"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('atelier-rama-tabs')) {
    customElements.define('atelier-rama-tabs', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.tabs = Array.from(this.querySelectorAll('[data-ar-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-ar-panel]'));
        this.tablist = this.querySelector('[role="tablist"]');
        if (!this.tabs.length || !this.tablist) return;

        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.panels.forEach((panel, index) => {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', this.tabs[index].id);
        });
        const remembered = this.tabs.findIndex(tab => tab.id === this.activeTabId);
        const initial = Math.max(0, Math.min(this.tabs.length - 1, (Number(this.dataset.initialTab) || 1) - 1));
        this.dataset.enhanced = 'true';
        this.activate(remembered >= 0 ? remembered : initial);
        this.tablist.hidden = false;

        this.tablist.addEventListener('click', event => {
          const index = this.tabs.indexOf(event.target.closest('[data-ar-tab]'));
          if (index >= 0) this.activate(index, false, true);
        }, options);

        this.tablist.addEventListener('keydown', event => {
          const current = this.tabs.indexOf(event.target.closest('[data-ar-tab]'));
          if (current < 0) return;
          let next;
          if (event.key === 'ArrowRight') next = (current + 1) % this.tabs.length;
          else if (event.key === 'ArrowLeft') next = (current - 1 + this.tabs.length) % this.tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.tabs.length - 1;
          else return;
          event.preventDefault();
          this.activate(next, true, true);
        }, options);

        if (window.Shopify && window.Shopify.designMode) {
          document.addEventListener('shopify:block:select', event => {
            const index = this.tabs.findIndex(tab => tab.dataset.blockId === event.detail.blockId);
            if (index >= 0) this.activate(index, false, true);
          }, options);
        }
      }

      disconnectedCallback() {
        if (this.controller) this.controller.abort();
        this.controller = null;
      }

      activate(index, focus = false, reveal = false) {
        this.tabs.forEach((tab, position) => {
          const selected = position === index;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          this.panels[position].hidden = !selected;
          this.panels[position].tabIndex = selected ? 0 : -1;
        });
        const selected = this.tabs[index];
        this.activeTabId = selected.id;
        if (focus) selected.focus({ preventScroll: true });
        if (reveal) {
          const tab = selected.getBoundingClientRect();
          const list = this.tablist.getBoundingClientRect();
          if (tab.left < list.left) this.tablist.scrollLeft += tab.left - list.left;
          else if (tab.right > list.right) this.tablist.scrollLeft += tab.right - list.right;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-reels-producto"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('atelier-product-reels')) {
  customElements.define('atelier-product-reels', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.track = this.querySelector('[data-reels-track]');
      if (!this.track) return;
      this.cards = Array.from(this.querySelectorAll('[data-reel-card]'));
      this.videos = this.cards.map(card => card.querySelector('video'));
      this.navigation = this.querySelector('[data-reels-navigation]');
      this.previous = this.querySelector('[data-reels-prev]');
      this.next = this.querySelector('[data-reels-next]');
      this.position = this.querySelector('[data-reels-position]');
      this.events = new AbortController();
      const options = {signal:this.events.signal};
      this.setAttribute('data-enhanced', '');

      this.cards.forEach(card => {
        const video = card.querySelector('video');
        const play = card.querySelector('[data-reel-play]');
        const error = card.querySelector('[data-reel-error]');
        const sources = Array.from(video.querySelectorAll('source'));
        const failedSources = new Set();
        const showError = () => {
          error.hidden = false;
          play.hidden = false;
        };
        sources.forEach(source => source.addEventListener('error', () => {
          failedSources.add(source);
          if (failedSources.size === sources.length) showError();
        }, options));
        video.controls = card.hasAttribute('data-started');
        video.tabIndex = video.controls ? 0 : -1;
        play.hidden = video.controls;
        play.addEventListener('click', () => {
          const retry = !error.hidden || video.error;
          document.dispatchEvent(new CustomEvent('atelier:reels:play', {detail:{video}}));
          error.hidden = true;
          card.setAttribute('data-started', '');
          video.controls = true;
          video.tabIndex = 0;
          const transferFocus = document.activeElement === play;
          play.hidden = true;
          if (retry) {
            failedSources.clear();
            video.load();
          }
          if (transferFocus) video.focus({preventScroll:true});
          const result = video.play();
          result?.catch(reason => {
            if (!this.isConnected || reason.name === 'AbortError') return;
            showError();
          });
        }, options);
        video.addEventListener('play', () => {
          error.hidden = true;
          play.hidden = true;
          card.setAttribute('data-started', '');
          document.dispatchEvent(new CustomEvent('atelier:reels:play', {detail:{video}}));
        }, options);
        video.addEventListener('error', showError, options);
      });

      document.addEventListener('atelier:reels:play', event => {
        this.videos.forEach(video => { if (video !== event.detail?.video) video.pause(); });
      }, options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.pauseAll();
      }, options);
      window.addEventListener('pagehide', () => this.pauseAll(), options);
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => this.scheduleUpdate(), {...options,passive:true});
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.scrollTo(event.key === 'Home' ? 0 : this.track.scrollWidth);
        }
      }, options);
      if ('ResizeObserver' in window) {
        this.resize = new ResizeObserver(() => this.scheduleUpdate());
        this.resize.observe(this.track);
      } else {
        window.addEventListener('resize', () => this.scheduleUpdate(), options);
      }
      if ('IntersectionObserver' in window) {
        this.visibility = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.intersectionRatio < 0.1 && !entry.target.paused && document.fullscreenElement !== entry.target && !entry.target.webkitDisplayingFullscreen && document.pictureInPictureElement !== entry.target) entry.target.pause();
          });
        }, {threshold:[0,0.1]});
        this.videos.forEach(video => this.visibility.observe(video));
      }
      this.scheduleUpdate();
    }
    pauseAll() { this.videos?.forEach(video => video.pause()); }
    scrollTo(left) {
      this.track.scrollTo({left,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }
    move(direction) {
      const width = this.cards[0]?.getBoundingClientRect().width || this.track.clientWidth;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const step = width + gap;
      const index = Math.round(this.track.scrollLeft / step);
      this.scrollTo((index + direction) * step);
    }
    scheduleUpdate() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.update());
    }
    update() {
      if (!this.isConnected || !this.track.clientWidth) return;
      const limit = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const overflow = limit > 2;
      this.navigation.hidden = !overflow;
      this.previous.disabled = !overflow || this.track.scrollLeft <= 2;
      this.next.disabled = !overflow || this.track.scrollLeft >= limit - 2;
      const bounds = this.track.getBoundingClientRect();
      const visible = this.cards.map((card,index) => ({rect:card.getBoundingClientRect(),index})).filter(item => item.rect.left < bounds.right - 8 && item.rect.right > bounds.left + 8);
      if (!visible.length) return;
      const first = visible[0].index + 1;
      const last = visible[visible.length - 1].index + 1;
      const label = 'Videos ' + (first === last ? first : first + '–' + last) + ' de ' + this.cards.length;
      if (this.position.textContent !== label) this.position.textContent = label;
    }
    disconnectedCallback() {
      this.pauseAll();
      this.events?.abort();
      this.events = null;
      this.resize?.disconnect();
      this.visibility?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-regalos-destacados"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('atelier-gift-banner')) {
    customElements.define('atelier-gift-banner', class extends HTMLElement {
      connectedCallback() {
        this.startFrame = requestAnimationFrame(() => this.setup());
      }

      setup() {
        this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-panel]'));
        this.list = this.querySelector('[data-tabs]');
        this.toggle = this.querySelector('[data-toggle]');
        this.stage = this.querySelector('[data-panels]');
        if (!this.panels.length || this.tabs.length !== this.panels.length) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.autoEnabled = this.dataset.autoplay === 'true' && this.panels.length > 1;
        this.paused = !this.autoEnabled || this.motion.matches || this.dataset.designMode === 'true' || Boolean(window.Shopify?.designMode);
        this.interval = Math.max(4000, Number(this.dataset.interval) || 7000);
        this.hovered = false;
        this.ignoreHover = false;
        const rect = this.getBoundingClientRect();
        this.inView = rect.bottom > 0 && rect.top < innerHeight;
        if (this.panels.length > 1) {
          this.setAttribute('aria-roledescription', 'carrusel');
          this.querySelector('.ar__controls').hidden = false;
          this.list.setAttribute('role', 'tablist');
          this.list.setAttribute('aria-orientation', 'horizontal');
          this.tabs.forEach((tab, index) => {
            tab.setAttribute('role', 'tab');
            tab.setAttribute('aria-controls', this.panels[index].id);
            this.panels[index].setAttribute('role', 'tabpanel');
            this.panels[index].setAttribute('aria-labelledby', tab.id);
            tab.addEventListener('click', () => {
              this.setPaused(true);
              this.activate(index, true);
            }, options);
            tab.addEventListener('keydown', event => {
              const positions = { ArrowLeft: (index - 1 + this.tabs.length) % this.tabs.length, ArrowRight: (index + 1) % this.tabs.length, Home: 0, End: this.tabs.length - 1 };
              if (!(event.key in positions)) return;
              event.preventDefault();
              this.setPaused(true);
              this.activate(positions[event.key], true);
            }, options);
          });
        }
        this.toggle.addEventListener('pointerdown', () => {
          this.pointerNextPaused = !this.paused;
        }, options);
        this.toggle.addEventListener('click', event => {
          const next = event.detail > 0 ? this.pointerNextPaused : !this.paused;
          this.ignoreHover = !next;
          this.setPaused(next);
        }, options);
        this.addEventListener('focusin', () => this.setPaused(true), options);
        this.addEventListener('pointerenter', event => {
          if (event.pointerType === 'touch') return;
          this.hovered = true;
          this.schedule();
        }, options);
        this.addEventListener('pointerleave', () => {
          this.hovered = false;
          this.ignoreHover = false;
          this.schedule();
        }, options);
        this.addEventListener('shopify:block:select', event => {
          const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail.blockId);
          if (index < 0) return;
          this.setPaused(true);
          this.activate(index);
        }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.motion.addEventListener('change', event => {
          if (event.matches) this.setPaused(true);
        }, options);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.inView = entries[0].isIntersecting;
            this.schedule();
          });
          this.observer.observe(this);
        }
        this.setAttribute('data-enhanced', '');
        this.activate(Math.min(this.index || 0, this.panels.length - 1));
        this.setPaused(this.paused);
      }

      activate(index, focus = false) {
        this.index = index;
        this.tabs.forEach((tab, i) => {
          const selected = i === index;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          this.panels[i].dataset.active = String(selected);
          this.panels[i].setAttribute('aria-hidden', String(!selected));
          this.panels[i].inert = !selected;
          this.panels[i].tabIndex = selected ? 0 : -1;
        });
        if (focus) this.tabs[index].focus({ preventScroll: true });
        const tab = this.tabs[index];
        const left = tab.offsetLeft - this.list.offsetLeft;
        if (left < this.list.scrollLeft) this.list.scrollLeft = left;
        else if (left + tab.offsetWidth > this.list.scrollLeft + this.list.clientWidth) this.list.scrollLeft = left + tab.offsetWidth - this.list.clientWidth;
        this.schedule();
      }

      setPaused(paused) {
        this.paused = Boolean(paused);
        this.toggle.textContent = this.paused ? this.dataset.playLabel : this.dataset.pauseLabel;
        this.stage.setAttribute('aria-live', this.paused ? 'polite' : 'off');
        this.schedule();
      }

      schedule() {
        clearTimeout(this.timer);
        if (!this.autoEnabled || this.paused || !this.inView || document.hidden || (this.hovered && !this.ignoreHover)) return;
        this.timer = setTimeout(() => this.activate((this.index + 1) % this.panels.length), this.interval);
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.startFrame);
        clearTimeout(this.timer);
        this.abort?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-regalos-por-ocasion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('atelier-occasion-filter')) {
    customElements.define('atelier-occasion-filter', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.setup());
      }

      setup() {
        this.grid = this.querySelector('[data-grid]');
        this.meta = this.querySelector('[data-catalog]');
        if (!this.grid || !this.meta) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.results = this.querySelector('[data-results]');
        this.status = this.querySelector('[data-status]');
        this.more = this.querySelector('[data-more]');
        this.fallback = this.querySelector('[data-fallback]');
        this.filters = Array.from(this.querySelectorAll('[data-filter-tag]'));
        this.groups = Array.from(this.querySelectorAll('[data-group]'));
        this.groupPanels = Array.from(this.querySelectorAll('[data-group-panel]'));
        this.pageSize = Number(this.dataset.pageSize) || 3;
        this.baseURL = new URL(window.location.href);
        this.baseURL.hash = '';
        this.pageParam = this.meta.dataset.pageParam || 'page';
        this.run = (this.run || 0) + 1;
        if (!this.pool) {
          this.pool = [];
          this.ids = new Set();
          this.lastPage = 0;
          if (Number(this.meta.dataset.page) > 1) {
            const firstURL = new URL(this.baseURL);
            firstURL.searchParams.set(this.pageParam, '1');
            this.nextURL = firstURL.href;
          } else {
            this.readBatch(this);
          }
        }
        if (this.groups.length) {
          this.querySelector('[data-groups]').setAttribute('role', 'tablist');
          this.groups.forEach((group, index) => {
            group.setAttribute('role', 'tab');
            const panel = this.groupPanels.find(p => p.dataset.groupPanel === group.dataset.group);
            group.setAttribute('aria-controls', panel.id);
            panel.setAttribute('role', 'tabpanel');
            panel.setAttribute('aria-labelledby', group.id);
            group.addEventListener('click', event => {
              event.preventDefault();
              this.chooseGroup(group.dataset.group);
            }, options);
            group.addEventListener('keydown', event => {
              const positions = { ArrowRight: (index + 1) % this.groups.length, ArrowLeft: (index - 1 + this.groups.length) % this.groups.length, Home: 0, End: this.groups.length - 1 };
              if (event.key === ' ') { event.preventDefault(); group.click(); return; }
              if (!(event.key in positions)) return;
              event.preventDefault();
              const next = this.groups[positions[event.key]];
              next.focus({ preventScroll: true });
              this.chooseGroup(next.dataset.group);
            }, options);
          });
        }
        this.filters.forEach(filter => {
          filter.setAttribute('role', 'button');
          filter.addEventListener('click', event => {
            if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
            event.preventDefault();
            this.choose(filter);
          }, options);
          filter.addEventListener('keydown', event => {
            if (event.key === ' ') { event.preventDefault(); filter.click(); }
          }, options);
        });
        this.more.addEventListener('click', event => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
          event.preventDefault();
          if (this.busy) return;
          const previous = this.limit;
          this.limit += this.pageSize;
          this.refresh(previous);
        }, options);
        this.addEventListener('shopify:block:select', event => {
          const group = this.groups.find(g => g.dataset.groupBlockId && g.dataset.groupBlockId === event.detail.blockId);
          if (group) this.chooseGroup(group.dataset.group);
          const filter = this.filters.find(f => f.dataset.blockId === event.detail.blockId);
          if (filter) { this.showGroup(filter.dataset.filterGroup); this.choose(filter); }
        }, options);
        this.setAttribute('data-enhanced', '');
        this.chooseGroup(this.activeGroup || this.dataset.initialGroup);
      }

      normalize(value) { return String(value).trim().normalize('NFC').toLocaleLowerCase(); }

      readBatch(root) {
        const meta = root.querySelector('[data-catalog]');
        const page = Number(meta?.dataset.page);
        if (!meta || page <= this.lastPage) throw new Error('Página de productos repetida o inválida');
        for (const child of root.querySelector('[data-grid]').children) {
          const card = child.matches('template') ? child.content.querySelector('[data-product-id]') : child;
          if (!card?.dataset.productId || this.ids.has(card.dataset.productId)) continue;
          const tags = JSON.parse(card.dataset.tags || '[]').map(tag => this.normalize(tag));
          this.pool.push({ element: card, tags });
          this.ids.add(card.dataset.productId);
        }
        this.lastPage = page;
        this.nextURL = meta.dataset.nextUrl || '';
      }

      showGroup(key) {
        this.activeGroup = key;
        this.groups.forEach(group => {
          const selected = group.dataset.group === key;
          group.dataset.active = String(selected);
          group.setAttribute('aria-selected', String(selected));
          group.tabIndex = selected ? 0 : -1;
        });
        this.groupPanels.forEach(panel => {
          const selected = panel.dataset.groupPanel === key;
          panel.dataset.active = String(selected);
          panel.hidden = !selected;
        });
      }

      chooseGroup(key) {
        this.showGroup(key);
        const all = this.filters.find(filter => filter.dataset.filterGroup === key && !filter.dataset.filterTag);
        if (all) this.choose(all);
      }

      choose(filter) {
        this.tag = this.normalize(filter.dataset.filterTag);
        this.limit = this.pageSize;
        this.more.href = filter.href;
        this.fallback.href = filter.href;
        this.filters.forEach(item => {
          const active = item === filter;
          item.dataset.active = String(active);
          item.setAttribute('aria-pressed', String(active));
        });
        this.refresh();
      }

      matches() { return this.tag ? this.pool.filter(card => card.tags.includes(this.tag)) : this.pool; }

      paint(pending = false) {
        const matches = this.matches();
        this.grid.replaceChildren(...matches.slice(0, this.limit).map(card => card.element));
        this.more.hidden = !(matches.length > this.limit || this.nextURL);
        this.more.setAttribute('aria-disabled', String(pending));
        this.results.setAttribute('aria-busy', String(pending));
        this.status.dataset.state = pending ? 'loading' : matches.length ? 'ready' : 'empty';
        this.status.textContent = pending ? 'Cargando productos…' : matches.length ? `${Math.min(matches.length, this.limit)} productos mostrados.` : this.dataset.emptyText;
      }

      async refresh(focusIndex) {
        const run = ++this.run;
        this.request?.abort();
        this.fallback.hidden = true;
        this.busy = true;
        this.paint(Boolean(this.nextURL && this.matches().length <= this.limit));
        try {
          while (this.nextURL && this.matches().length <= this.limit) {
            await this.loadNext(run);
            if (run !== this.run || !this.isConnected) return;
          }
          this.busy = false;
          this.paint();
          if (Number.isInteger(focusIndex)) this.grid.children[focusIndex]?.querySelector('a')?.focus({ preventScroll: true });
        } catch (error) {
          if (run !== this.run || !this.isConnected) return;
          this.busy = false;
          this.paint();
          this.status.dataset.state = 'error';
          this.status.textContent = 'No pudimos cargar más productos. Podés volver a intentarlo o abrir la selección completa.';
          this.fallback.hidden = false;
        }
      }

      async loadNext(run) {
        const next = new URL(this.nextURL, this.baseURL);
        const page = next.searchParams.get(this.pageParam);
        if (!page) throw new Error('Falta el número de página');
        const url = new URL(this.baseURL);
        url.searchParams.set(this.pageParam, page);
        url.searchParams.delete('sections');
        url.searchParams.set('section_id', this.dataset.sectionId);
        const request = new AbortController();
        this.request = request;
        const timeout = setTimeout(() => request.abort(), 15000);
        try {
          const response = await fetch(url.href, { signal: request.signal, credentials: 'same-origin', headers: { Accept: 'text/html' } });
          if (!response.ok) throw new Error('No se pudo cargar la sección');
          const html = await response.text();
          if (run !== this.run) return;
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const root = parsed.getElementById(this.id);
          if (!root || root.dataset.collection !== this.dataset.collection) throw new Error('Respuesta de colección incorrecta');
          this.readBatch(root);
        } finally {
          clearTimeout(timeout);
        }
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.run = (this.run || 0) + 1;
        this.events?.abort();
        this.request?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-selector-regalos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('atelier-gift-finder')) {
    customElements.define('atelier-gift-finder', class extends HTMLElement {
      connectedCallback() { this.initFrame = requestAnimationFrame(() => this.init()); }
      init() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.rules = Array.from(this.querySelectorAll('template[data-rule]'));
        this.results = this.querySelector('[data-results]');
        this.empty = this.querySelector('template[data-empty]');
        this.status = this.querySelector('[data-status]');
        this.submit = this.querySelector('[data-show-results]');
        const quiz = this.querySelector('[data-quiz]');
        if (!quiz) return;
        quiz.hidden = false;
        this.addEventListener('change', event => {
          if (event.target.matches('input[data-question]')) this.update();
        }, options);
        this.submit.addEventListener('click', () => {
          const linked = this.linkedOption();
          if (linked) {
            window.location.assign(linked.dataset.link);
            return;
          }
          this.update();
          const heading = this.results.querySelector('[data-result-heading]');
          heading.focus({ preventScroll: true });
          heading.scrollIntoView({ behavior: this.motion(), block: 'start' });
        }, options);
        this.addEventListener('submit', event => {
          const form = event.target.closest('form[data-combo-form]');
          if (!form) return;
          event.preventDefault();
          this.addCombo(form);
        }, options);
        this.querySelectorAll('[data-all-gifts]').forEach(link => link.addEventListener('click', event => {
          const id = event.currentTarget.getAttribute('href').slice(1);
          const target = document.getElementById(id);
          if (!target) return;
          event.preventDefault();
          const top = target.getBoundingClientRect().top + window.scrollY - 120;
          window.scrollTo({ top: Math.max(0, top), behavior: this.motion() });
          const focus = target.matches('a,button,input,[tabindex]') ? target : target.querySelector('h2,h3,a,button');
          if (focus) {
            const hadIndex = focus.hasAttribute('tabindex');
            if (!hadIndex) focus.setAttribute('tabindex', '-1');
            focus.focus({ preventScroll: true });
            if (!hadIndex) focus.addEventListener('blur', () => focus.removeAttribute('tabindex'), { once: true });
          }
        }, options));
        document.addEventListener('shopify:block:select', event => {
          const rule = this.rules.find(item => item.dataset.blockId === event.detail.blockId);
          if (!rule) return;
          for (let q = 1; q <= 3; q++) {
            if (rule.dataset['q' + q] !== 'any') {
              const radio = this.querySelector('input[data-question="' + q + '"][value="' + rule.dataset['q' + q] + '"]');
              if (radio) radio.checked = true;
            }
          }
          this.syncLink();
          this.show(rule, false);
        }, options);
        this.observer = new ResizeObserver(entries => {
          const width = entries[0].contentRect.width;
          if (width !== this.lastWidth) { this.lastWidth = width; this.align(); }
        });
        this.observer.observe(this);
        this.update(false);
        document.fonts.ready.then(() => { if (this.isConnected) this.align(); });
      }
      motion() { return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
      linkedOption() { return this.querySelector('input[data-question="1"][data-link]:checked'); }
      syncLink() {
        const linked = this.linkedOption();
        this.querySelectorAll('[data-question-group]').forEach(group => {
          if (group.dataset.questionGroup !== '1') group.disabled = Boolean(linked);
        });
        const label = this.submit && this.submit.querySelector('span');
        if (label) label.textContent = linked ? linked.dataset.linkLabel : this.dataset.submitLabel;
        this.classList.toggle('agf--link', Boolean(linked));
        return linked;
      }
      update(announce = true) {
        const linked = this.syncLink();
        if (linked) {
          const panel = this.querySelector('template[data-link-panel][data-option="' + linked.value + '"]');
          if (panel) { this.show(panel, announce); return; }
        }
        const answers = [1, 2, 3].map(q => this.querySelector('input[data-question="' + q + '"]:checked')?.value);
        let winner = null, best = -1;
        for (const rule of this.rules) {
          if (rule.dataset.enabled !== 'true' || Number(rule.dataset.count) === 0) continue;
          let matches = true, score = 0;
          answers.forEach((answer, i) => {
            const condition = rule.dataset['q' + (i + 1)];
            if (condition !== 'any') { score++; if (condition !== answer) matches = false; }
          });
          if (matches && score > best) { best = score; winner = rule; }
        }
        this.show(winner || this.empty, announce);
      }
      show(template, announce) {
        if (this.current !== template) {
          this.results.replaceChildren(template.content.cloneNode(true));
          this.current = template;
          this.align();
        }
        if (announce) {
          const heading = this.results.querySelector('[data-result-heading]');
          this.status.textContent = heading?.textContent || '';
        }
      }
      async addCombo(form) {
        const button = form.querySelector('button[type="submit"]');
        const error = form.querySelector('[data-combo-error]');
        if (!button || button.disabled) return;
        const items = Array.from(form.querySelectorAll('input[name="items[][id]"]'))
          .map(input => ({ id: Number(input.value), quantity: 1 }));
        const label = button.textContent;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        if (error) error.hidden = true;
        try {
          const response = await fetch(this.dataset.cartAddUrl + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          });
          const data = await response.json().catch(() => ({}));
          if (!response.ok) throw new Error(data.description || data.message || '');
          if (this.dataset.comboRedirect === 'true') {
            window.location.assign(this.dataset.cartUrl);
            return;
          }
          button.textContent = this.dataset.addedLabel;
          button.setAttribute('data-added', '');
          const cartLink = form.querySelector('[data-cart-link]');
          if (cartLink) cartLink.hidden = false;
          this.status.textContent = this.dataset.addedLabel;
          document.dispatchEvent(new CustomEvent('atelier:cart:added', { detail: { items } }));
        } catch (problem) {
          button.textContent = label;
          button.disabled = false;
          const message = problem.message || this.dataset.errorLabel;
          if (error) { error.textContent = message; error.hidden = false; }
          this.status.textContent = message;
        } finally {
          button.removeAttribute('aria-busy');
        }
      }
      align() {
        if (!this.results) return;
        for (const [selector, variable] of [['.agf__product-title', '--agf-product-title'], ['.agf__price', '--agf-price-height'], ['.agf__products .agf__product-button', '--agf-button-height']]) {
          this.results.style.setProperty(variable, '0px');
          const nodes = Array.from(this.results.querySelectorAll(selector));
          const height = Math.max(0, ...nodes.map(node => node.getBoundingClientRect().height));
          this.results.style.setProperty(variable, Math.ceil(height) + 'px');
        }
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = null;
        this.current = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-visitanos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('atelier-store-visit')) {
    customElements.define('atelier-store-visit', class extends HTMLElement {
      connectedCallback() {
        this.frameId = requestAnimationFrame(() => {
          if (this.controller) return;
          this.controller = new AbortController();
          const button = this.querySelector('[data-load-map]');
          const frame = this.querySelector('iframe[data-src]');
          if (!button || !frame) return;
          button.hidden = false;
          button.addEventListener('click', () => {
            const src = frame.dataset.src;
            if (!src) return;
            frame.src = src;
            frame.removeAttribute('data-src');
            frame.hidden = false;
            this.querySelector('[data-map-cover]').hidden = true;
            frame.focus({ preventScroll: true });
          }, { once: true, signal: this.controller.signal });
        });
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frameId);
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    if (!customElements.get('footer-menu')) {
      customElements.define('footer-menu', FooterMenu);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
